// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-07T17:12:06.567Z
// Property: Reserve at Long Point (ID: 6737460151192644)
// Collections: 31 amenities, 13 floorplans (live), 54 photos, 107 POIs, 4 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6737460151192644",
  "property_external_id": "5026481",
  "property_zillow_url": "https://www.zillow.com/apartments/hattiesburg-ms/reserve-at-long-point/5XxcBz/",
  "property_apartments_url": "https://www.apartments.com/reserve-at-long-point-hattiesburg-ms/yjen6fr",
  "property_google_business_url": "https://www.google.com/maps/place/Reserve+at+Long+Point/data=!4m2!3m1!1s0x0:0x319ffc3bb8261070?sa=X&ved=2ahUKEwjDufLXzLySAxWNa0EAHZAcItkQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "17321251416",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "reserve-at-long-point",
  "property_name": "Reserve at Long Point",
  "property_website_url": "https://www.reservelongpoint.com/",
  "property_domain": "https://www.reservelongpoint.com/",
  "property_address": "700 Beverly Hills Rd",
  "property_full_address": "700 Beverly Hills Rd, Hattiesburg, MS 39401",
  "property_address_1": "700 Beverly Hills Rd",
  "property_address_2": null,
  "property_address_city": "Hattiesburg",
  "property_address_state": "MS",
  "property_address_zip_full": "39401-4494",
  "property_address_zip": "39401",
  "property_address_country": "US",
  "property_address_county": "Forrest County",
  "property_neighborhood_address": "Hattiesburg/South Area",
  "property_address_latitude": "31.3364192",
  "property_address_longitude": "-89.3455196",
  "property_email": "reservelongpoint@rrliving.com",
  "property_phone": "(601) 579-4779",
  "property_call_tracking_phone": "601-202-9275",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Reserve at Long Point in Hattiesburg, MS! Explore our versatile floor plans, including one, two, and three-bedroom options, designed for comfort and style. Enjoy top-notch amenities like a sparkling swimming pool, 24-hour fitness center, and a welcoming dog park. Find your new home today—browse our availability or schedule a tour!",
  "property_long_description": "**Discover Your Perfect Home at Reserve at Long Point in Hattiesburg, MS!**\n\nWelcome to Reserve at Long Point, where comfort meets convenience in a vibrant community tailored to your lifestyle. Our diverse range of floor plans includes one, two, and three-bedroom apartments, each thoughtfully designed with modern living in mind. Enjoy your private patio or balcony, perfect for morning coffees or evening relaxation, while exploring our spacious layouts ideal for every need. \n\nOur exceptional amenities promise a lifestyle of leisure and activity. Take a refreshing dip in one of our two sparkling swimming pools, connect with friends in the stylish clubroom, or host a barbecue in the community gas grill area. For fitness enthusiasts, our 24-hour fitness center and basketball court will keep you active, while our two playgrounds and dog park cater to families and furry friends alike.\n\nAt Reserve at Long Point, your convenience is our priority. Benefit from 24-hour on-call maintenance and management, an online payment system, and seamless access to our business center and conference room. Enjoy ample parking, including covered options, and take advantage of our car wash stations, ensuring your vehicle stays in pristine shape.\n\nSituated with direct access to the beautiful Vulcan Trail, our gated community offers a perfect balance of tranquility and accessibility. With features like controlled building access, storage space, and a dedicated courtesy officer, you will feel secure and at home.\n\nWhether you’re looking to unwind by the gas fire pit or socialize in our vibrant community, Reserve at Long Point is the perfect choice. **Find your new home today - browse our availability or schedule a tour to experience our exceptional living firsthand!**",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e848a-1fe3-779b-a2d4-9e1c35669eab.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background",
    "public_id": "019e848a-1fe3-779b-a2d4-9e1c35669eab",
    "storage_key": "property/6737460151192644/019e848a-1fe3-779b-a2d4-9e1c35669eab.webp",
    "width": 3072,
    "height": 2048
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "210",
  "property_year_built": "2008",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "99.52380952380952",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": "3",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Each apartment may have up to 3 pets, with a limit of 2 dogs per home. No breed restrictions.",
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://reserveatlongpoint.loftliving.com/login",
  "property_apply_now_url": "https://8921438.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e8489-feab-728d-9675-b9c1775a0c22.webp",
  "property_primary_logo_media": {
    "alt_text": "Reserve at Long Point Apartment Homes logo",
    "public_id": "019e8489-feab-728d-9675-b9c1775a0c22",
    "storage_key": "property/6737460151192644/019e8489-feab-728d-9675-b9c1775a0c22.webp",
    "width": 1463,
    "height": 227
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e8489-feab-728d-9675-b9c1775a0c22.webp",
  "property_secondary_logo_media": {
    "alt_text": "Reserve at Long Point Apartment Homes logo",
    "public_id": "019e8489-feab-728d-9675-b9c1775a0c22",
    "storage_key": "property/6737460151192644/019e8489-feab-728d-9675-b9c1775a0c22.webp",
    "width": 1463,
    "height": 227
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e8e86-f2fe-71e2-9ba7-177089e8b150.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019e8e86-f2fe-71e2-9ba7-177089e8b150",
    "storage_key": "property/6737460151192644/019e8e86-f2fe-71e2-9ba7-177089e8b150.webp",
    "width": 351,
    "height": 54
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd7-d683-72dc-b8de-45a3cd6e0900.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Reserve at Long Point Apartment Homes logo.",
    "public_id": "019e1dd7-d683-72dc-b8de-45a3cd6e0900",
    "storage_key": "property/6737460151192644/019e1dd7-d683-72dc-b8de-45a3cd6e0900.webp",
    "width": 351,
    "height": 54
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#ffd046",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#fff2cc",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 3",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "3",
  "property_sqft_range": "845 - 1416",
  "property_sqft_min": "845",
  "property_sqft_max": "1416",
  "property_price_range": "1216 - 1943",
  "property_price_min": "1216",
  "property_price_max": "1943",
  "property_available_units": 1,
  "property_facebook_url": "https://www.facebook.com/ReserveatLongPoint",
  "property_instagram_url": "https://www.instagram.com/reserveatlongpoint",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJndQW4cbenIgRcBAmuDv8nzE",
  "property_youtube_url": "https://www.youtube.com/watch?t=880&v=eWbrgHrlsN0",
  "property_yelp_url": "https://www.yelp.com/biz/reserve-at-long-point-by-hamilton-point-investments-hattiesburg",
  "property_tiktok_url": "https://www.tiktok.com/@reserveatlongpoint",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Reserve at Long Point",
  "property_home_romance_title": "Embrace a Heartfelt Home in Your Dream Community",
  "property_home_amenities_blurb": "<p>The lovely <a href=\"/floor-plans/\">apartment</a> community, Reserve at Long Point, is located in beautiful Hattiesburg, MS, known as \"Hub City.\" Our residents will enjoy many mouthwatering restaurants, local shops, and entertainment attractions with easy access to major US highways.</p>",
  "property_home_floorplans_blurb": "<p>Hello neighbor! See how amazing the neighborhood around Reserve at Long Point in Hattiesburg, MS is. With easy access to many major highways, our <a href=\"/floor-plans/\">apartments</a> for rent are conveniently located near local shopping, dining, entertainment, parks, and schools. See for yourself when you schedule a tour!</p>",
  "property_home_gallery_blurb": "At Reserve at Long Point in Hattiesburg, MS, your ideal home awaits among spacious one, two, and three-bedroom floor plans. Enjoy remarkable amenities from a tranquil pond and picnic area to a state-of-the-art fitness center. With 24-hour access and on-site management, a vibrant lifestyle is just a step away. Picture yourself living here!",
  "property_home_neighborhood_blurb": "Discover the vibrant neighborhood surrounding Reserve at Long Point in Hattiesburg, MS. Explore our diverse floor plans—one, two, and three-bedroom apartments—while enjoying local favorites and nearby points of interest. See what's around our community and start your journey to your new home today!",
  "property_home_reviews_blurb": "At Reserve at Long Point in Hattiesburg, MS, residents thrive in a vibrant community filled with young professionals and students. With timely maintenance, friendly staff, and a welcoming atmosphere, one resident attests, \"We have made amazing friends here and have enjoyed our stay.\" Join a social haven that feels like home!",
  "property_neighborhood_blurb": "<p>Hello neighbor! See how amazing the neighborhood around Reserve at Long Point in Hattiesburg, MS is. With easy access to many major highways, our <a href=\"/floor-plans/\">apartments</a> for rent are conveniently located near local shopping, dining, entertainment, parks, and schools. See for yourself when you schedule a tour!</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Poise and sophistication are evident with only the most desired features our homes for rent offer. Incomparable character, functionality, and attention to detail await you in each classy designed <a href=\"/floor-plans/\">apartment</a>.</p>",
  "property_applynow_blurb": "Welcome to Reserve at Long Point in Hattiesburg, MS, where comfort meets convenience. Choose from spacious one, two, or three-bedroom floor plans and enjoy exclusive amenities like a sparkling swimming pool, fitness center, and private patios. Explore our community offerings and apply online today to secure your new home!",
  "property_contactus_blurb": "Discover your perfect home at Reserve at Long Point in Hattiesburg, MS! With spacious one, two, and three-bedroom floor plans, we cater to your lifestyle needs. Explore all our options and find your ideal apartment today. Have questions? Contact our leasing team today!",
  "property_faqs_blurb": "Discover your ideal home at Reserve at Long Point in Hattiesburg, MS. Offering spacious one, two, and three-bedroom floor plans, our community perfectly suits your lifestyle. Have questions? Browse our FAQs page to find answers about our amenities and features, ensuring you have all the information you need.",
  "property_floorplans_blurb": "<p>We offer modern one, two, and three bedroom apartment homes with precise and refined <a href=\"/amenities/\">amenities</a>. Incomparable character, functionality, and attention to detail await you in each classy designed apartment. Opportunity starts with us at Reserve at Long Point apartments in <a href=\"/neighborhood/\">Hattiesburg, Mississippi.</a></p>",
  "property_gallery_blurb": "<p>Nothing helps you to imagine the possibilities for a new apartment home quite like photography. Take a look at photo collections that capture the unique and beautiful spaces in our <a href=\"/amenities/\">community</a> and <a href=\"/floor-plans/\">apartments</a>.</p>",
  "property_interactivemap_blurb": "Discover your dream home at Reserve at Long Point in Hattiesburg, MS! Choose from spacious one, two, and three-bedroom floor plans featuring private patios, gas grills, and ample parking. Enjoy top-notch amenities, including a sparkling swimming pool, 24-hour fitness center, and on-site management. Use our interactive community map to find your perfect apartment today!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "At Reserve at Long Point in Hattiesburg, MS, our diverse floor plans, including one, two, and three-bedroom apartments, cater to every lifestyle. Great friends make great neighbors—refer a friend to our vibrant community today and explore the perfect home together! View all our floor plans now!",
  "property_residentaccess_blurb": "Welcome to Reserve at Long Point in Hattiesburg, MS! Choose from our thoughtfully designed one, two, and three-bedroom floor plans, tailored to fit your lifestyle. Residents can easily access our portal to pay rent, schedule maintenance, and more. Log in today and make your living experience seamless!",
  "property_reviews_blurb": "At Reserve at Long Point in Hattiesburg, MS, residents rave about the vibrant community of young professionals and students. One happy renter shares, \"We have made amazing friends here and have enjoyed our stay.\" Embrace a life of connection—read more about what our residents love!",
  "property_created_at": "1752257259312",
  "property_scheduletour_blurb": "Discover your perfect home at Reserve at Long Point in Hattiesburg, MS. Our versatile floor plans include one, two, and three-bedroom options tailored to your lifestyle. Ready to explore? Schedule a tour today and see what our residents have to say about living in our welcoming community!",
  "property_thankyou_blurb": "Thank you for your interest in Reserve at Long Point in Hattiesburg, MS! Explore our diverse floor plans, featuring one, two, and three-bedroom options tailored to your lifestyle. A member of our team will reach out shortly to assist you in finding your perfect home. Stay tuned!",
  "property_virtualtours_blurb": "<p>At Reserve at Long Point, we make finding your new home quick & easy with our beautiful virtual tours. Explore 360-degree views of your new apartment home & the exceptional amenities that accompany it.</p>",
  "property_copyright": "2025 All Rights Reserved. Reserve at Long Point",
  "property_seo_title_home": "Reserve at Long Point | Apartments in Hattiesburg, MS",
  "property_seo_description_home": "Discover your perfect home at Reserve at Long Point in Hattiesburg, MS! Our community offers spacious one, two, and three-bedroom floor plans, complete with private patios, gas fire pits, and sparkling swimming pools. Enjoy extensive amenities like a 24-hour fitness center, on-site management, and dog park access, all within a gated environment. With online resident services and direct access to the Vulcan Trail, your convenience and comfort are our top priorities. Experience the best in apartment living—find your new home today!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in Hattiesburg, MS",
  "property_seo_description_floorplans": "Discover your ideal living space at Reserve at Long Point in Hattiesburg, MS! Explore our diverse floor plans, featuring one, two, and three-bedroom options designed to fit every lifestyle. Whether you seek cozy spaces or spacious layouts, we have something for everyone. Browse our available apartment homes today and find your perfect floor plan!",
  "property_seo_title_amenities": "Amenities | Hattiesburg, MS Apartments for Rent",
  "property_seo_description_amenities": "Discover your ideal home at Reserve at Long Point in Hattiesburg, MS! Our stunning one, two, and three-bedroom apartments feature private patios, gas grills, and easy access to a sparkling swimming pool. Enjoy 24-hour fitness and on-call maintenance, plus a range of amenities including a dog park, business center, and clubroom. Experience the convenience of online resident services and ample parking, all within a gated community tailored for your comfort. Explore our amazing community amenities and apartment features today!",
  "property_seo_title_gallery": "Gallery | Apartments in Hattiesburg, MS",
  "property_seo_description_gallery": "Explore the Reserve at Long Point in Hattiesburg, MS, where modern comfort meets upscale living! Browse our stunning photo gallery showcasing spacious one, two, and three-bedroom floor plans complemented by premier amenities like a sparkling swimming pool, 24-hour fitness center, and gas fire pit. Enjoy private patios, ample parking, and an inviting clubhouse—perfect for relaxation and socializing. Discover our vibrant community featuring playgrounds, dog parks, and direct access to the Vulcan Trail. Picture yourself living here and experience the lifestyle you deserve!",
  "property_seo_title_virtualtours": "Virtual Tours | Reserve at Long Point Apartments",
  "property_seo_description_virtualtours": "Explore your future home at Reserve at Long Point in Hattiesburg, MS! Discover spacious one, two, and three-bedroom floor plans designed for comfort and style. Take a virtual tour of our community and apartments for rent today and envision your new life here!",
  "property_seo_title_interactivemap": "Interactive Map | Reserve at Long Point Apartments",
  "property_seo_description_interactivemap": "Discover your ideal living space at Reserve at Long Point in Hattiesburg, MS! With a variety of spacious floor plans—one, two, and three bedrooms—you're sure to find the perfect fit. Enjoy top-notch amenities such as private patios, sparkling swimming pools, a 24-hour fitness center, and a dog park. Explore our enhanced online resident services and on-call maintenance for ultimate convenience. Ready to find your new home? Use our interactive community map to check availability and pricing today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Hattiesburg, MS",
  "property_seo_description_neighborhood": "Discover the vibrant neighborhood surrounding Reserve at Long Point in Hattiesburg, MS. Explore our diverse floor plans, including one, two, and three-bedroom apartments, and uncover local favorites and nearby attractions. See what's around our community and start your next adventure today!",
  "property_seo_title_contact": "Contact Us | Reserve at Long Point",
  "property_seo_description_contact": "Discover your perfect home at Reserve at Long Point in Hattiesburg, MS! Explore our spacious floor plans, including one, two, and three-bedroom apartments tailored to meet your lifestyle needs. Have questions? Contact our leasing team today and take the first step towards your new living experience!",
  "property_seo_title_faqs": "FAQs | Apartments in Hattiesburg, MS",
  "property_seo_description_faqs": "\"Discover your ideal home at Reserve at Long Point in Hattiesburg, MS! Explore our spacious one, two, and three-bedroom floor plans, and enjoy fabulous amenities like private patios, a sparkling swimming pool, a 24-hour fitness center, and dog parks. Our community features gated access, covered parking, and 24/7 maintenance for your convenience. Have questions? Browse our FAQs page for answers and learn more about our vibrant community today!\"",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Hattiesburg, MS",
  "property_seo_description_reviews": "Discover why residents love living at the Reserve at Long Point in Hattiesburg, MS! Explore our spacious one, two, and three-bedroom apartment floor plans featuring private patios, gas grills, and access to our sparkling swimming pool, 24-hour fitness center, and dog park. Enjoy top-notch amenities like online resident services, ample parking, and gated access for peace of mind. Join a vibrant community with endless recreational options and exceptional management. See what our residents have to say about living at our community! Your new home awaits!",
  "property_seo_title_applynow": "Apply Now | Apartments in Hattiesburg, MS",
  "property_seo_description_applynow": "Discover your perfect sanctuary at Reserve at Long Point in Hattiesburg, MS! Choose from spacious one, two, or three-bedroom floor plans designed for comfort. Enjoy exceptional amenities like two sparkling pools, a 24-hour fitness center, and a welcoming clubhouse. Relax on your private patio, host barbecues at our gas grills, or explore the convenience of our online resident services and 24-hour maintenance support. With direct access to the Vulcan Trail, a dog park, and ample parking, you’ll experience unmatched convenience and recreation. Ready to elevate your lifestyle? Find your new home and lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Reserve at Long Point",
  "property_seo_description_residentaccess": "\"Welcome to the Reserve at Long Point in Hattiesburg, MS! Access your resident portal now to conveniently pay rent, schedule maintenance, and manage your community services with ease. Join our vibrant community today!\"",
  "property_seo_title_referafriend": "Refer A Friend | Reserve at Long Point",
  "property_seo_description_referafriend": "\"Discover the Reserve at Long Point in Hattiesburg, MS! Great friends make great neighbors – refer a friend to our vibrant apartment community today and enjoy exclusive rewards. Join us in making lasting memories together!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Reserve at Long Point",
  "property_seo_description_scheduletour": "\"Explore your dream home at Reserve at Long Point in Hattiesburg, MS! Schedule a tour today to discover our exceptional amenities, spacious floor plans, and welcoming community that awaits you. Your perfect apartment living experience is just a visit away!\"",
  "property_seo_title_privacy": "Privacy Policy | Reserve at Long Point",
  "property_seo_description_privacy": "\"Discover the Reserve at Long Point in Hattiesburg, MS, where your privacy matters. Explore our comprehensive privacy policy to learn how we protect your information while you enjoy your new apartment community. View our privacy policy today!\"",
  "property_seo_title_accessibility": "Website Accessibility | Reserve at Long Point",
  "property_seo_description_accessibility": "\"Discover a welcoming community at Reserve at Long Point in Hattiesburg, MS. Our Accessibility Statement reflects our commitment to digital inclusion, ensuring everyone can easily explore our apartment offerings. Join us in creating an accessible living experience—learn more today!\"",
  "property_seo_title_sitemap": "Sitemap | Reserve at Long Point",
  "property_seo_description_sitemap": "Discover the comprehensive sitemap for Reserve at Long Point in Hattiesburg, MS! Explore our community's amenities, floor plans, and services. Uncover everything you need to make an informed decision about your future home. View our website sitemap today!",
  "property_seo_title_thankyou": "Thank You | Reserve at Long Point",
  "property_seo_description_thankyou": "Thank you for reaching out to Reserve at Long Point in Hattiesburg, MS! We appreciate your interest in our vibrant apartment community. A member of our team will be in touch soon to assist you in finding your perfect home. Stay tuned for updates and exciting information about life at Reserve at Long Point!",
  "property_seo_title_pets": "Pet Policy | Apartments in Hattiesburg, MS",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293657972",
  "amenities": [
    {
      "id": "ec_982552f96ddd520875432615",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "generator",
      "external_id": "false",
      "title": "24‑Hour Courtesy Patrol",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dc6f8de727ea30abf5f4cf91",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "generator",
      "external_id": "false",
      "title": "Access to Public Transportation",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c74353f33c09c2e91bfc6a07",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "generator",
      "external_id": "false",
      "title": "Beautiful Landscaping",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_00104c22c28b20d8f284719b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "generator",
      "external_id": "false",
      "title": "Billiards",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ef7c41b402a43410da1761b2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "generator",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_056daefacfd3c1056213fcd3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "generator",
      "external_id": "false",
      "title": "Corporate Housing Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e452e2887b6dd3d23fdfdfc5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "generator",
      "external_id": "false",
      "title": "Disability Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_87e4fa88727c9423b682af34",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "generator",
      "external_id": "false",
      "title": "Easy Access to Freeways",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c3537028c2b91f50e86fe2d9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "generator",
      "external_id": "false",
      "title": "Easy Access to Shopping",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1651608713cead9976408f29",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "generator",
      "external_id": "false",
      "title": "Gated Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_419b367cff7f68cb1b4af738",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "generator",
      "external_id": "false",
      "title": "Guest Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b1927875324fc133db173a3b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "generator",
      "external_id": "false",
      "title": "High‑Speed Internet Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_00aa7ef82b06194ea1ffc992",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "generator",
      "external_id": "false",
      "title": "On‑call and On‑site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_afc78e1c585fb27c09fc294b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "generator",
      "external_id": "false",
      "title": "Pet‑Friendly Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1e28fe09ff3571ec41235b4a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "generator",
      "external_id": "false",
      "title": "Resort‑Style Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_085867894a925feac4c22cb3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "generator",
      "external_id": "false",
      "title": "24‑Hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_48bbfab9ffe67c58f41828aa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "generator",
      "external_id": "false",
      "title": "9‑Foot Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e15c5faa2004dc67662cb49d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "generator",
      "external_id": "false",
      "title": "All‑Electric Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_24e3ed9dce5ab53e8c29b706",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "generator",
      "external_id": "false",
      "title": "Private Patio or Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5aa96a291631006cd6bef571",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "generator",
      "external_id": "false",
      "title": "Disability Access",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d8acc1e4cad42acd635e862a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "generator",
      "external_id": "false",
      "title": "Garages for Rent Based on Availability*",
      "amount": "false",
      "description": "*Available in Select Homes",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c81ba77f44ba10bd13f60445",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "generator",
      "external_id": "false",
      "title": "Hardwood Floors*",
      "amount": "false",
      "description": "*Available in Select Homes",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_09124628fe6eadfc39269d24",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "generator",
      "external_id": "false",
      "title": "Vaulted Ceilings*",
      "amount": "false",
      "description": "*Available in Select Homes",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_06382c709bec2afc30d035da",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "generator",
      "external_id": "false",
      "title": "Walk‑in Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fa3bf2f63c72ee6f07781f4d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "generator",
      "external_id": "false",
      "title": "Washer and Dryer Included",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_45b567665627112320394489",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "generator",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "(Newly Updated Homes)",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_864189b27ced573a07757ba3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "generator",
      "external_id": "false",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "(Newly Updated Homes)",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4305d27464c78ad8d979a545",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "generator",
      "external_id": "false",
      "title": "Plank Flooring",
      "amount": "false",
      "description": "(Newly Updated Homes)",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3b04f5ee5b69b1fff95bb3fa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "generator",
      "external_id": "false",
      "title": "Farm House Sink",
      "amount": "false",
      "description": "(Newly Updated Homes)",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d2cbc96cbe3ad00701922940",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "generator",
      "external_id": "false",
      "title": "Modern Led Light Fixtures",
      "amount": "false",
      "description": "(Newly Updated Homes)",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c3456051029a44490c42e2e8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "generator",
      "external_id": "false",
      "title": "Gooseneck Faucets with Built‑in Sprayer",
      "amount": "false",
      "description": "(Newly Updated Homes)",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_1561bfc5-9d3e-43be-96e7-a3a5428cccd1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/01a087d7-489f-7322-a564-0b1f2a5c1a97.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and a cabana.",
        "public_id": "01a087d7-489f-7322-a564-0b1f2a5c1a97",
        "storage_key": "property/6737460151192644/01a087d7-489f-7322-a564-0b1f2a5c1a97.webp",
        "width": 1449,
        "height": 1085
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by our stunning swimming pool, complete with ample lounge seating and a covered cabana.",
      "link": "",
      "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and a cabana.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7fcd3aca-bf60-4a23-ad1e-a5292a39dd2c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/01a087d7-5fe5-7127-acf6-329b669d7add.webp",
      "image_media": {
        "alt_text": "Lobby seating area with leather chairs and a coffee table.",
        "public_id": "01a087d7-5fe5-7127-acf6-329b669d7add",
        "storage_key": "property/6737460151192644/01a087d7-5fe5-7127-acf6-329b669d7add.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lobby, featuring comfortable seating and a modern aesthetic.",
      "link": "",
      "alt_text": "Lobby seating area with leather chairs and a coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_08ab2b97-f12d-4fbd-8944-f63312ee2a97",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/01a087d7-46f0-73dc-bb0f-e148bc0f9557.webp",
      "image_media": {
        "alt_text": "Cozy living room with a sofa, armchairs, and coffee table.",
        "public_id": "01a087d7-46f0-73dc-bb0f-e148bc0f9557",
        "storage_key": "property/6737460151192644/01a087d7-46f0-73dc-bb0f-e148bc0f9557.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Relax in the spacious and beautifully decorated living room of your new apartment.",
      "link": "",
      "alt_text": "Cozy living room with a sofa, armchairs, and coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c00e8cdd-1240-41c8-99aa-e05231522ab1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/01a087d7-5fe4-76b6-bfbb-5e654aacf019.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, dresser, closet, and ceiling fan.",
        "public_id": "01a087d7-5fe4-76b6-bfbb-5e654aacf019",
        "storage_key": "property/6737460151192644/01a087d7-5fe4-76b6-bfbb-5e654aacf019.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "A beautifully appointed bedroom featuring a comfortable king-size bed, ample closet space, and a ceiling fan for added comfort. The room is decorated with tasteful artwork and includes a dresser for storage.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, dresser, closet, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4fed6ea1-518e-4a4d-ac17-4fc7404a56c1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/01a087d7-5c7b-70c4-8ea6-f5de8a0f83ee.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and granite countertops.",
        "public_id": "01a087d7-5c7b-70c4-8ea6-f5de8a0f83ee",
        "storage_key": "property/6737460151192644/01a087d7-5c7b-70c4-8ea6-f5de8a0f83ee.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Experience culinary delights in this beautifully appointed kitchen, featuring sleek stainless steel appliances, ample white cabinetry, and elegant granite countertops.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_996247b6-62b6-4e3c-8554-6f769a7809fd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/01a087d7-4d32-75aa-920b-b6c82fd61281.webp",
      "image_media": {
        "alt_text": "Double vanity with granite countertops and dual sinks, illuminated by modern vanity lights.",
        "public_id": "01a087d7-4d32-75aa-920b-b6c82fd61281",
        "storage_key": "property/6737460151192644/01a087d7-4d32-75aa-920b-b6c82fd61281.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed bathroom featuring a spacious double vanity with granite countertops, dual sinks, and elegant fixtures. Enjoy ample storage and a bright, inviting atmosphere.",
      "link": "",
      "alt_text": "Double vanity with granite countertops and dual sinks, illuminated by modern vanity lights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_602533bd-5fac-4411-9934-9b0886d67527",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/01a087d7-5fdb-749d-9d1b-a39ee2f9c0ea.webp",
      "image_media": {
        "alt_text": "Treadmills, ellipticals, and weight machines in a spacious, well-lit gym with mirrors and ceiling fans.",
        "public_id": "01a087d7-5fdb-749d-9d1b-a39ee2f9c0ea",
        "storage_key": "property/6737460151192644/01a087d7-5fdb-749d-9d1b-a39ee2f9c0ea.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center features a variety of cardio and strength training equipment to help you stay active and healthy.",
      "link": "",
      "alt_text": "Treadmills, ellipticals, and weight machines in a spacious, well-lit gym with mirrors and ceiling fans.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6993d53a-ce08-4025-b509-1254fa0d2ac9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/01a087d7-5ce8-75ae-8706-d0fa47927a9d.webp",
      "image_media": {
        "alt_text": "Billiard table and lounge area with seating",
        "public_id": "01a087d7-5ce8-75ae-8706-d0fa47927a9d",
        "storage_key": "property/6737460151192644/01a087d7-5ce8-75ae-8706-d0fa47927a9d.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy friendly competition in our billiards room, or relax in the comfortable lounge area.",
      "link": "",
      "alt_text": "Billiard table and lounge area with seating",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c5cf27d2-807a-49da-b6e3-fff87d4abd8a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/01a087d7-5791-772b-88e7-1ff08af118cc.webp",
      "image_media": {
        "alt_text": "Coffee station with a coffee machine, cups, and a mini-fridge stocked with drinks.",
        "public_id": "01a087d7-5791-772b-88e7-1ff08af118cc",
        "storage_key": "property/6737460151192644/01a087d7-5791-772b-88e7-1ff08af118cc.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy complimentary coffee and beverages at our convenient coffee station, featuring a modern coffee machine and a selection of drinks in the mini-fridge.",
      "link": "",
      "alt_text": "Coffee station with a coffee machine, cups, and a mini-fridge stocked with drinks.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9fdebc78-6fa0-41eb-a265-17ef00e3ff28",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/01a087d7-46f8-72fe-b558-7e49560bb081.webp",
      "image_media": {
        "alt_text": "Community craft room with gift wrapping supplies, computers, and a table.",
        "public_id": "01a087d7-46f8-72fe-b558-7e49560bb081",
        "storage_key": "property/6737460151192644/01a087d7-46f8-72fe-b558-7e49560bb081.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy creative pursuits in our community craft room, equipped with gift wrapping stations and computer access for residents.",
      "link": "",
      "alt_text": "Community craft room with gift wrapping supplies, computers, and a table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fc0b5298-f5f5-4aa0-bd4e-bf875bc8c3b6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e848a-1fe3-779b-a2d4-9e1c35669eab.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background",
        "public_id": "019e848a-1fe3-779b-a2d4-9e1c35669eab",
        "storage_key": "property/6737460151192644/019e848a-1fe3-779b-a2d4-9e1c35669eab.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by lush landscaping and comfortable lounge chairs. Perfect for relaxation and fun.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_82885287-a37e-4909-85ec-7a44cb635871",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd8-563e-74be-8c61-78f20f01d620.webp",
      "image_media": {
        "alt_text": "Kitchen and dining area with white cabinets, granite countertops, and wood-look flooring.",
        "public_id": "019e1dd8-563e-74be-8c61-78f20f01d620",
        "storage_key": "property/6737460151192644/019e1dd8-563e-74be-8c61-78f20f01d620.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "A spacious kitchen and dining area featuring modern white cabinetry, granite countertops, stainless steel appliances, and elegant wood-look flooring.",
      "link": "",
      "alt_text": "Kitchen and dining area with white cabinets, granite countertops, and wood-look flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f886bbc0-98eb-46e5-b421-80cd886f0ce3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd8-7d96-75ee-8cbc-068217b02e3f.webp",
      "image_media": {
        "alt_text": "Modern bedroom with queen bed, dresser, and ceiling fan.",
        "public_id": "019e1dd8-7d96-75ee-8cbc-068217b02e3f",
        "storage_key": "property/6737460151192644/019e1dd8-7d96-75ee-8cbc-068217b02e3f.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Relax in comfort in this stylish bedroom, complete with a plush queen-sized bed, elegant dresser, and convenient ceiling fan.",
      "link": "",
      "alt_text": "Modern bedroom with queen bed, dresser, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bf8eda12-19fc-42ca-a3bc-c940db856a28",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd8-376c-756c-8a60-d2b5ba5cdb96.webp",
      "image_media": {
        "alt_text": "Kitchen with stainless steel appliances, white cabinets, and granite countertops.",
        "public_id": "019e1dd8-376c-756c-8a60-d2b5ba5cdb96",
        "storage_key": "property/6737460151192644/019e1dd8-376c-756c-8a60-d2b5ba5cdb96.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "A bright and functional kitchen featuring modern stainless steel appliances, ample white cabinetry, and elegant granite countertops, perfect for preparing meals.",
      "link": "",
      "alt_text": "Kitchen with stainless steel appliances, white cabinets, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9b6b143b-eccc-441b-863e-ee95846c1bb4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd8-6562-775d-838c-b0d698bc33bc.webp",
      "image_media": {
        "alt_text": "A primary bedroom featuring a queen-size bed with pink and gray bedding, a vanity, and a walk-in closet.",
        "public_id": "019e1dd8-6562-775d-838c-b0d698bc33bc",
        "storage_key": "property/6737460151192644/019e1dd8-6562-775d-838c-b0d698bc33bc.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Relax in comfort in this spacious primary bedroom, complete with a plush queen bed, elegant vanity, and ample closet space for all your needs.",
      "link": "",
      "alt_text": "A primary bedroom featuring a queen-size bed with pink and gray bedding, a vanity, and a walk-in closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_432619f1-5669-4cfc-a39c-51507998980f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd8-49bd-74fe-bc8c-1ad847bb6164.webp",
      "image_media": {
        "alt_text": "Bedroom with a ceiling fan and view into a bathroom.",
        "public_id": "019e1dd8-49bd-74fe-bc8c-1ad847bb6164",
        "storage_key": "property/6737460151192644/019e1dd8-49bd-74fe-bc8c-1ad847bb6164.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring plush carpeting, a modern ceiling fan, and easy access to a well-appointed bathroom. Experience comfort and convenience in your new home.",
      "link": "",
      "alt_text": "Bedroom with a ceiling fan and view into a bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6982965b-d35a-418f-b677-a1bdce5fc5ae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd8-3c0b-75e2-8c03-6a3ba0b5f0ba.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, granite countertops, stainless steel appliances, and a window.",
        "public_id": "019e1dd8-3c0b-75e2-8c03-6a3ba0b5f0ba",
        "storage_key": "property/6737460151192644/019e1dd8-3c0b-75e2-8c03-6a3ba0b5f0ba.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring white cabinetry, granite countertops, a stainless steel refrigerator, stove, and microwave, perfect for everyday cooking.",
      "link": "",
      "alt_text": "Kitchen with white cabinets, granite countertops, stainless steel appliances, and a window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_830d8a07-c9df-4448-a691-d073cb32c675",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e848b-5054-77d8-a992-83db0a6e0735.webp",
      "image_media": {
        "alt_text": "Modern lounge area with leather chairs, coffee station, and view of pool.",
        "public_id": "019e848b-5054-77d8-a992-83db0a6e0735",
        "storage_key": "property/6737460151192644/019e848b-5054-77d8-a992-83db0a6e0735.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish resident lounge, featuring comfortable seating, complimentary coffee, and a view of the sparkling outdoor pool.",
      "link": "",
      "alt_text": "Modern lounge area with leather chairs, coffee station, and view of pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_80752c22-221e-47f5-b382-16fb67d78155",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e848b-36f3-7608-a3d5-cc88e523082d.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and granite countertops.",
        "public_id": "019e848b-36f3-7608-a3d5-cc88e523082d",
        "storage_key": "property/6737460151192644/019e848b-36f3-7608-a3d5-cc88e523082d.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "A bright and modern kitchen featuring sleek stainless steel appliances, ample white cabinetry, and elegant granite countertops. Perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a2bf4d2f-410f-4eb4-bbf7-a926de2ef654",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd8-67e1-7326-af9e-4be44f1c37d0.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, sink, toilet, and shower/tub.",
        "public_id": "019e1dd8-67e1-7326-af9e-4be44f1c37d0",
        "storage_key": "property/6737460151192644/019e1dd8-67e1-7326-af9e-4be44f1c37d0.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious bathroom with a granite-top vanity, sink, toilet, and a shower/tub combination. Ample storage is available in the cabinet above the toilet.",
      "link": "",
      "alt_text": "Bathroom with vanity, sink, toilet, and shower/tub.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6a3585b8-040d-4fb9-98ca-841d21eef523",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd8-67e1-7326-af9e-462eb898b4a3.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a patterned shower curtain, white vanity, and granite countertop.",
        "public_id": "019e1dd8-67e1-7326-af9e-462eb898b4a3",
        "storage_key": "property/6737460151192644/019e1dd8-67e1-7326-af9e-462eb898b4a3.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Step into a clean and modern bathroom featuring a stylish shower curtain, a spacious vanity with a granite countertop, and ample storage space.",
      "link": "",
      "alt_text": "Modern bathroom with a patterned shower curtain, white vanity, and granite countertop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_65b9f24e-b2ba-4467-bd6c-7f4554ef5b7d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e848b-47bc-75cc-a22d-1fec09a301d3.webp",
      "image_media": {
        "alt_text": "Lobby area with modern seating and decorative ceiling.",
        "public_id": "019e848b-47bc-75cc-a22d-1fec09a301d3",
        "storage_key": "property/6737460151192644/019e848b-47bc-75cc-a22d-1fec09a301d3.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax in the stylish lobby, featuring comfortable seating, a large television, and elegant decor. Perfect for meeting guests or enjoying a quiet moment.",
      "link": "",
      "alt_text": "Lobby area with modern seating and decorative ceiling.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d35f5778-9ea6-4183-a4d1-8d98a03e73fe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e848b-5108-749e-baa4-ecb351ce53f5.webp",
      "image_media": {
        "alt_text": "Clubhouse lounge area with leather chairs and a coffee station.",
        "public_id": "019e848b-5108-749e-baa4-ecb351ce53f5",
        "storage_key": "property/6737460151192644/019e848b-5108-749e-baa4-ecb351ce53f5.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax in the comfortable lounge area of our clubhouse, featuring plush seating and a convenient coffee station. Perfect for socializing or unwinding.",
      "link": "",
      "alt_text": "Clubhouse lounge area with leather chairs and a coffee station.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_306159be-61fb-4846-9510-c8c8f259a65e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e848b-437e-7188-8d29-47f1cf134675.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical machines, weight machines, and a wellness banner.",
        "public_id": "019e848b-437e-7188-8d29-47f1cf134675",
        "storage_key": "property/6737460151192644/019e848b-437e-7188-8d29-47f1cf134675.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Stay active and healthy in our fully-equipped fitness center, featuring a variety of cardio and strength training equipment for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with treadmills, elliptical machines, weight machines, and a wellness banner.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_67bd70a5-bb7f-4c2f-bb09-471fba6e1e2a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e848b-4047-7770-a91a-603aeb551de9.webp",
      "image_media": {
        "alt_text": "Business center with computers and a conference table.",
        "public_id": "019e848b-4047-7770-a91a-603aeb551de9",
        "storage_key": "property/6737460151192644/019e848b-4047-7770-a91a-603aeb551de9.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Stay connected and productive in our modern business center, featuring computers and a comfortable conference table for your convenience.",
      "link": "",
      "alt_text": "Business center with computers and a conference table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5c661eaa-48fa-4b77-bc07-77fd3059c100",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e848b-4050-7137-8ba1-9f4703c37d5b.webp",
      "image_media": {
        "alt_text": "Dining room with a round table, four chairs, and decorative wall art.",
        "public_id": "019e848b-4050-7137-8ba1-9f4703c37d5b",
        "storage_key": "property/6737460151192644/019e848b-4050-7137-8ba1-9f4703c37d5b.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Elegant dining room featuring a round wooden table set for four, complemented by stylish upholstered chairs and unique starburst wall decor. Perfect for intimate meals.",
      "link": "",
      "alt_text": "Dining room with a round table, four chairs, and decorative wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_03536a32-93f7-4988-9a55-087826b58831",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e848b-2bf9-7151-be2e-182f3d2540b8.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool and surrounding lounge chairs at a multifamily property.",
        "public_id": "019e848b-2bf9-7151-be2e-182f3d2540b8",
        "storage_key": "property/6737460151192644/019e848b-2bf9-7151-be2e-182f3d2540b8.webp",
        "width": 1777,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our stunning outdoor swimming pool, complete with ample lounge seating for ultimate relaxation. The perfect amenity for sunny days.",
      "link": "",
      "alt_text": "Aerial view of a resort-style swimming pool and surrounding lounge chairs at a multifamily property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b84e0043-e267-4a42-81c4-5ef4aee257a8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e848b-37cd-75ce-91c3-eb3c3ac17b59.webp",
      "image_media": {
        "alt_text": "Signage for Reserve at Long Point Apartment Homes, with a stone wall and landscaping.",
        "public_id": "019e848b-37cd-75ce-91c3-eb3c3ac17b59",
        "storage_key": "property/6737460151192644/019e848b-37cd-75ce-91c3-eb3c3ac17b59.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Reserve at Long Point Apartment Homes, featuring beautiful grounds and excellent amenities for a comfortable living experience.",
      "link": "",
      "alt_text": "Signage for Reserve at Long Point Apartment Homes, with a stone wall and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4833abab-25bc-4d6a-915d-f61a694a35fd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e848b-5693-71b8-addc-a0390992e0f9.webp",
      "image_media": {
        "alt_text": "Large outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019e848b-5693-71b8-addc-a0390992e0f9",
        "storage_key": "property/6737460151192644/019e848b-5693-71b8-addc-a0390992e0f9.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool, surrounded by lush landscaping and comfortable lounge seating.",
      "link": "",
      "alt_text": "Large outdoor swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ae65605a-e5e6-4e2c-86ae-e2c59b860919",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e848b-54c9-767e-9cc9-dcbc367d3e46.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a clubhouse on a sunny day.",
        "public_id": "019e848b-54c9-767e-9cc9-dcbc367d3e46",
        "storage_key": "property/6737460151192644/019e848b-54c9-767e-9cc9-dcbc367d3e46.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, surrounded by lush landscaping and comfortable lounge chairs. Perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and a clubhouse on a sunny day.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8d7ab076-0021-4411-8aad-e8b9ee16c261",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e848b-53cb-713e-a22e-e521b6f0baba.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "019e848b-53cb-713e-a22e-e521b6f0baba",
        "storage_key": "property/6737460151192644/019e848b-53cb-713e-a22e-e521b6f0baba.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning resort-style swimming pool, complete with comfortable lounge chairs and ample shade from umbrellas. Perfect for a sunny day.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d7d54f56-509e-4858-86b4-6593144dc347",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e848b-53e2-75f1-b006-e16a16e00ffe.webp",
      "image_media": {
        "alt_text": "Resort-style pool with lounge chairs and apartments in the background",
        "public_id": "019e848b-53e2-75f1-b006-e16a16e00ffe",
        "storage_key": "property/6737460151192644/019e848b-53e2-75f1-b006-e16a16e00ffe.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our beautiful resort-style pool. Lounge chairs and surrounding apartments create a perfect oasis.",
      "link": "",
      "alt_text": "Resort-style pool with lounge chairs and apartments in the background",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_11ca6a31-25ce-4651-afb5-8e5694cd1f5d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e848b-5330-7171-aac6-0aa845d05bc2.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with a brick fireplace and pergola.",
        "public_id": "019e848b-5330-7171-aac6-0aa845d05bc2",
        "storage_key": "property/6737460151192644/019e848b-5330-7171-aac6-0aa845d05bc2.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax and unwind in our beautiful outdoor living space, featuring a cozy fireplace and comfortable seating.",
      "link": "",
      "alt_text": "Outdoor seating area with a brick fireplace and pergola.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_31b71de2-5079-4674-8709-a306933dfa1f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e848b-4448-70ee-80e1-0d48b5b9111a.webp",
      "image_media": {
        "alt_text": "Lounge area with comfortable seating, coffee station, and a TV.",
        "public_id": "019e848b-4448-70ee-80e1-0d48b5b9111a",
        "storage_key": "property/6737460151192644/019e848b-4448-70ee-80e1-0d48b5b9111a.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lounge area, complete with plush seating, a convenient coffee station, and entertainment options.",
      "link": "",
      "alt_text": "Lounge area with comfortable seating, coffee station, and a TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8cd2a79f-f74b-49fc-a84c-0e88c18371b1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e848b-41dd-7547-86ff-b357320de014.webp",
      "image_media": {
        "alt_text": "Living room with a blue sofa, coffee table, and large window.",
        "public_id": "019e848b-41dd-7547-86ff-b357320de014",
        "storage_key": "property/6737460151192644/019e848b-41dd-7547-86ff-b357320de014.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious living room with modern decor, including a blue sofa, a stylish coffee table, and a large window overlooking the balcony. Perfect for relaxing or entertaining guests.",
      "link": "",
      "alt_text": "Living room with a blue sofa, coffee table, and large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_01bed664-d2ad-4ca7-bfcd-cbf94cecb881",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e848b-4024-733e-9366-49e0bc9e026e.webp",
      "image_media": {
        "alt_text": "Lounge area with a pool table, comfortable seating, and a mounted TV.",
        "public_id": "019e848b-4024-733e-9366-49e0bc9e026e",
        "storage_key": "property/6737460151192644/019e848b-4024-733e-9366-49e0bc9e026e.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy leisure time in our community lounge, featuring a pool table, ample seating, and a large screen TV for entertainment.",
      "link": "",
      "alt_text": "Lounge area with a pool table, comfortable seating, and a mounted TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7b4ec343-683f-44f3-8dcb-81c777965a4e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e848b-3f71-765f-88c8-5c418b34876d.webp",
      "image_media": {
        "alt_text": "Living room with blue sofa, coffee table, and view of kitchen.",
        "public_id": "019e848b-3f71-765f-88c8-5c418b34876d",
        "storage_key": "property/6737460151192644/019e848b-3f71-765f-88c8-5c418b34876d.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a navy blue sofa with decorative pillows, a modern coffee table, and an open-concept kitchen with white cabinetry and stainless steel appliances.",
      "link": "",
      "alt_text": "Living room with blue sofa, coffee table, and view of kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5ebda9fa-09d2-4d79-ad5c-26839d418b07",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e848b-0d22-73fa-bf46-4d531513b83d.webp",
      "image_media": {
        "alt_text": "Sunny outdoor swimming pool with lounge chairs and surrounding apartment buildings.",
        "public_id": "019e848b-0d22-73fa-bf46-4d531513b83d",
        "storage_key": "property/6737460151192644/019e848b-0d22-73fa-bf46-4d531513b83d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, perfect for relaxation and fun. Lounge chairs are available for sunbathing.",
      "link": "",
      "alt_text": "Sunny outdoor swimming pool with lounge chairs and surrounding apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_13182e9d-1773-4a4d-973e-2968110f3360",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e848b-3074-743c-9af1-0a0c26e7d03e.webp",
      "image_media": {
        "alt_text": "A clean and comfortable bedroom featuring a queen-size bed with plush bedding and a blue headboard.",
        "public_id": "019e848b-3074-743c-9af1-0a0c26e7d03e",
        "storage_key": "property/6737460151192644/019e848b-3074-743c-9af1-0a0c26e7d03e.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Relax and unwind in your spacious bedroom, complete with a comfortable queen-size bed and ample natural light from the large window.",
      "link": "",
      "alt_text": "A clean and comfortable bedroom featuring a queen-size bed with plush bedding and a blue headboard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9b1bcb63-1a24-4fe1-8657-fa011ce4ea0d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e848b-1ba3-750b-92fe-e69feff76e6d.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment complex with pool and surrounding neighborhood.",
        "public_id": "019e848b-1ba3-750b-92fe-e69feff76e6d",
        "storage_key": "property/6737460151192644/019e848b-1ba3-750b-92fe-e69feff76e6d.webp",
        "width": 1777,
        "height": 1333
      },
      "title": "Community",
      "description": "Expansive aerial view showcasing a modern apartment community, complete with a sparkling blue swimming pool and ample parking, nestled amidst lush greenery and residential streets.",
      "link": "",
      "alt_text": "Aerial view of apartment complex with pool and surrounding neighborhood.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_63ff4b42-0901-4eb1-a5bd-6df70978b146",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e848a-2217-76ce-a3e7-ae6523489e0b.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and an outdoor fireplace.",
        "public_id": "019e848a-2217-76ce-a3e7-ae6523489e0b",
        "storage_key": "property/6737460151192644/019e848a-2217-76ce-a3e7-ae6523489e0b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our sparkling resort-style swimming pool, perfect for relaxing or entertaining. Featuring comfortable lounge chairs and a cozy outdoor fireplace area for those cooler evenings.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and an outdoor fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c7dbd79f-f2b0-4d38-afb7-cbaefbc2f251",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e848a-0bcd-702b-96bf-76824123f1cb.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019e848a-0bcd-702b-96bf-76824123f1cb",
        "storage_key": "property/6737460151192644/019e848a-0bcd-702b-96bf-76824123f1cb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool, complete with comfortable lounge chairs and surrounded by the beautiful apartment buildings.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0805d1fa-f63a-410a-ba73-000dbd2e5d8f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e848a-06cf-70ac-bf3b-846932b8a7d5.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and tables in front of a clubhouse.",
        "public_id": "019e848a-06cf-70ac-bf3b-846932b8a7d5",
        "storage_key": "property/6737460151192644/019e848a-06cf-70ac-bf3b-846932b8a7d5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling resort-style swimming pool, surrounded by comfortable lounge chairs and outdoor seating areas, perfect for relaxation or socializing.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and tables in front of a clubhouse.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_57280bb6-6a63-43b6-804c-07b2faa39eac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e848a-0b6e-7001-9b33-ec3296d3557c.webp",
      "image_media": {
        "alt_text": "Sparkling blue swimming pool with lounge chairs and a white building with a covered patio.",
        "public_id": "019e848a-0b6e-7001-9b33-ec3296d3557c",
        "storage_key": "property/6737460151192644/019e848a-0b6e-7001-9b33-ec3296d3557c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our crystal-clear pool, surrounded by lush landscaping and comfortable lounge areas. Perfect for relaxation and fun under the sun.",
      "link": "",
      "alt_text": "Sparkling blue swimming pool with lounge chairs and a white building with a covered patio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e8d17049-bbfc-4597-a225-91ef2d02fc21",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e848a-10ee-73b6-8e8d-13856b9118a0.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and a covered seating area with a fireplace.",
        "public_id": "019e848a-10ee-73b6-8e8d-13856b9118a0",
        "storage_key": "property/6737460151192644/019e848a-10ee-73b6-8e8d-13856b9118a0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and a beautifully landscaped courtyard with a cozy fireplace.",
      "link": "",
      "alt_text": "Swimming pool with lounge chairs and a covered seating area with a fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d86a99cd-0a3a-40e6-a883-6640027fb342",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e848a-0745-703e-82b1-ce5517eec4f9.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019e848a-0745-703e-82b1-ce5517eec4f9",
        "storage_key": "property/6737460151192644/019e848a-0745-703e-82b1-ce5517eec4f9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and surrounded by beautifully maintained apartment buildings.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0c9996e5-7402-43d4-9453-f93a1d66e859",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e848a-0092-70bf-a1b2-ca1ef491d008.webp",
      "image_media": {
        "alt_text": "Row of detached garages with dark gray doors and white siding.",
        "public_id": "019e848a-0092-70bf-a1b2-ca1ef491d008",
        "storage_key": "property/6737460151192644/019e848a-0092-70bf-a1b2-ca1ef491d008.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Secure your vehicle in one of our spacious detached garages, offering convenient parking and extra storage space.",
      "link": "",
      "alt_text": "Row of detached garages with dark gray doors and white siding.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9b27977b-3613-412b-9dca-895917630f47",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd8-9570-720c-8fdb-9311c7124285.webp",
      "image_media": {
        "alt_text": "Washer and dryer in a closet.",
        "public_id": "019e1dd8-9570-720c-8fdb-9311c7124285",
        "storage_key": "property/6737460151192644/019e1dd8-9570-720c-8fdb-9311c7124285.webp",
        "width": 1024,
        "height": 1536
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer for your convenience.",
      "link": "",
      "alt_text": "Washer and dryer in a closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b2bbb6ff-93e8-474d-8e97-0e9ed3ceb9b9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd8-79b6-7575-866a-fb8aa53b497e.webp",
      "image_media": {
        "alt_text": "Bathroom with a white tub, toilet, and vanity with granite countertop.",
        "public_id": "019e1dd8-79b6-7575-866a-fb8aa53b497e",
        "storage_key": "property/6737460151192644/019e1dd8-79b6-7575-866a-fb8aa53b497e.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Enjoy this spacious bathroom featuring a white bathtub with black accent tiles, a toilet, and a modern vanity with a granite countertop and ample storage.",
      "link": "",
      "alt_text": "Bathroom with a white tub, toilet, and vanity with granite countertop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_92fa22be-bb6f-41a3-8087-7fe41963edac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd8-7777-7438-8ae6-c2f6cb72d16e.webp",
      "image_media": {
        "alt_text": "Closet with shelf and hanging rod, open to a bedroom with blinds.",
        "public_id": "019e1dd8-7777-7438-8ae6-c2f6cb72d16e",
        "storage_key": "property/6737460151192644/019e1dd8-7777-7438-8ae6-c2f6cb72d16e.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious closet with ample shelving and hanging space, leading into a well-lit bedroom.",
      "link": "",
      "alt_text": "Closet with shelf and hanging rod, open to a bedroom with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4ceeba53-4663-4022-a6a6-74384e764819",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd8-7976-768d-a3b8-9e9424aad1f8.webp",
      "image_media": {
        "alt_text": "Bedroom with ceiling fan and window blinds.",
        "public_id": "019e1dd8-7976-768d-a3b8-9e9424aad1f8",
        "storage_key": "property/6737460151192644/019e1dd8-7976-768d-a3b8-9e9424aad1f8.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a ceiling fan, a large window with blinds, and plush carpeting. Ample wall space for decor.",
      "link": "",
      "alt_text": "Bedroom with ceiling fan and window blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b1cd81da-44e0-4786-90fb-a25fb97ed431",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd8-6e17-75f1-81f2-3a8128224c73.webp",
      "image_media": {
        "alt_text": "Double vanity bathroom with granite countertops and a mirrored medicine cabinet.",
        "public_id": "019e1dd8-6e17-75f1-81f2-3a8128224c73",
        "storage_key": "property/6737460151192644/019e1dd8-6e17-75f1-81f2-3a8128224c73.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Spacious double vanity bathroom featuring granite countertops, ample cabinet space, and a large mirror. View of a bedroom through the open doorway.",
      "link": "",
      "alt_text": "Double vanity bathroom with granite countertops and a mirrored medicine cabinet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_598d3942-4fb5-4d03-9b20-1dfefcc7273c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd8-3bc0-7534-9e3a-6df72ce320ab.webp",
      "image_media": {
        "alt_text": "Living room with wood-look flooring and a ceiling fan.",
        "public_id": "019e1dd8-3bc0-7534-9e3a-6df72ce320ab",
        "storage_key": "property/6737460151192644/019e1dd8-3bc0-7534-9e3a-6df72ce320ab.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious living area with large windows and beautiful wood-look floors. Perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room with wood-look flooring and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_aa9610a7-a34a-4e64-bdd2-53301d15064e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd8-3bbf-7678-b1ee-e8ca1d2b3112.webp",
      "image_media": {
        "alt_text": "Empty dining area with two windows and a chandelier",
        "public_id": "019e1dd8-3bbf-7678-b1ee-e8ca1d2b3112",
        "storage_key": "property/6737460151192644/019e1dd8-3bbf-7678-b1ee-e8ca1d2b3112.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Bright and airy dining area, perfect for meals and entertaining. Features natural light from two large windows and elegant overhead lighting.",
      "link": "",
      "alt_text": "Empty dining area with two windows and a chandelier",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_7da04c8a-da93-4979-8117-8c5456109645",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Ed's Burger Joint",
      "poi_type": "Restaurants",
      "poi_address": "3800 Hardy St, Hattiesburg, MS 39402, USA",
      "poi_short_description": "Playful haunt with hubcap decor, serving cheeseburgers, hot dogs, shakes, salads & tap beers.",
      "poi_long_description": "Playful haunt with hubcap decor, serving cheeseburgers, hot dogs, shakes, salads & tap beers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd8-caa7-71a9-8dc7-848ee79691fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd8-caa7-71a9-8dc7-848ee79691fc",
        "storage_key": "property/6737460151192644/019e1dd8-caa7-71a9-8dc7-848ee79691fc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.edsburgerjoint.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3534322060485548743&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eds-burger-joint",
      "poi_latitude": "31.3245565",
      "poi_longitude": "-89.3458168",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 601-602-2601",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0cbf-71dc-9f12-48c766facff1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0cbf-71dc-9f12-48c766facff1",
        "storage_key": "property/6737460151192644/019e1dd9-0cbf-71dc-9f12-48c766facff1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ6mg-uvenIgRx1oROTBvDDE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_605fa293-81bc-462d-92bf-723752440ad1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Crossroads Coffee Roasters",
      "poi_type": "Restaurants",
      "poi_address": "3416 Hardy St #120, Hattiesburg, MS 39402, USA",
      "poi_short_description": "Cool, Midtown coffee shop with a selection of teas, plus pastries like blondies.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-c382-75ba-8818-bd70f8864dab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-c382-75ba-8818-bd70f8864dab",
        "storage_key": "property/6737460151192644/019e1dd9-c382-75ba-8818-bd70f8864dab.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://crossroadscoffeeroasters.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16710649643592001052&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crossroads-coffee-roasters",
      "poi_latitude": "31.3245458",
      "poi_longitude": "-89.34076519999999",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 601-336-5235",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dda-0dac-748d-8127-0b529d05736d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-0dac-748d-8127-0b529d05736d",
        "storage_key": "property/6737460151192644/019e1dda-0dac-748d-8127-0b529d05736d.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJu69DjWnfnIgRHCZPZFAn6Oc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_0169fe38-86c2-4a89-b357-306f77e91a98",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Southbound Bagel and Coffee Shop",
      "poi_type": "Restaurants",
      "poi_address": "217 E Front St, Hattiesburg, MS 39401, USA",
      "poi_short_description": "Compact, down-to-earth cafe supplying coffee, espresso, hot breakfast, sandwiches & bagels.",
      "poi_long_description": "Compact, down-to-earth cafe supplying coffee, espresso, hot breakfast, sandwiches & bagels.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-c826-7305-a367-69e00de3ae68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-c826-7305-a367-69e00de3ae68",
        "storage_key": "property/6737460151192644/019e1dd9-c826-7305-a367-69e00de3ae68.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.southboundbagelandcoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1860038829144737279&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southbound-bagel-and-coffee-shop",
      "poi_latitude": "31.32714",
      "poi_longitude": "-89.28863199999999",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 601-336-7339",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0cbf-71dc-9f12-48c766facff1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0cbf-71dc-9f12-48c766facff1",
        "storage_key": "property/6737460151192644/019e1dd9-0cbf-71dc-9f12-48c766facff1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYQiLZV7cnIgR_wWbz3Uv0Bk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_751f1dfa-4f10-47ee-9aa3-8951d1beb182",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Bourbon on Front",
      "poi_type": "Restaurants",
      "poi_address": "206 W Front St, Hattiesburg, MS 39401, USA",
      "poi_short_description": "Cozy American restaurant serving steaks, seafood, and cocktails, plus happy hour specials.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-c2aa-774a-96e8-c24eed21821a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-c2aa-774a-96e8-c24eed21821a",
        "storage_key": "property/6737460151192644/019e1dd9-c2aa-774a-96e8-c24eed21821a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.bourbon-on-front.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1845517813058317833&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bourbon-on-front",
      "poi_latitude": "31.32524909999999",
      "poi_longitude": "-89.2905676",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 601-336-7097",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0cbf-71dc-9f12-48c766facff1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0cbf-71dc-9f12-48c766facff1",
        "storage_key": "property/6737460151192644/019e1dd9-0cbf-71dc-9f12-48c766facff1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJU6gzKfjdnIgRCS7_SayYnBk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_c25e5d07-83aa-421e-a173-5a08379ee56f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Patio 44 Hattiesburg",
      "poi_type": "Restaurants",
      "poi_address": "3822 W 4th St, Hattiesburg, MS 39402, USA",
      "poi_short_description": "Elegant restaurant & bar featuring steak, seafood & New American fare, plus a spacious patio.",
      "poi_long_description": "Elegant restaurant & bar featuring steak, seafood & New American fare, plus a spacious patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-be53-73e7-8aa4-7025fa227883.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-be53-73e7-8aa4-7025fa227883",
        "storage_key": "property/6737460151192644/019e1dd9-be53-73e7-8aa4-7025fa227883.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://patiofortyfour.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7513539041420876504&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "patio-44-hattiesburg",
      "poi_latitude": "31.3354678",
      "poi_longitude": "-89.3486872",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 601-602-6907",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0cbf-71dc-9f12-48c766facff1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0cbf-71dc-9f12-48c766facff1",
        "storage_key": "property/6737460151192644/019e1dd9-0cbf-71dc-9f12-48c766facff1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJaVEB-MPenIgR2JrrIfNzRWg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_b62e4eeb-76af-4e6d-b1f5-7083b0a6e978",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Keg & Barrel",
      "poi_type": "Restaurants",
      "poi_address": "1315 Hardy St, Hattiesburg, MS 39401, USA",
      "poi_short_description": "Southern pub grub & 120+ beers served up in a late 19th-century home with a wraparound porch.",
      "poi_long_description": "Southern pub grub & 120+ beers served up in a late 19th-century home with a wraparound porch.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-c2bf-763e-ad25-2436b2dc7a2a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-c2bf-763e-ad25-2436b2dc7a2a",
        "storage_key": "property/6737460151192644/019e1dd9-c2bf-763e-ad25-2436b2dc7a2a.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "http://www.kegandbarrel.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6654975939494149616&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "keg--barrel",
      "poi_latitude": "31.3249821",
      "poi_longitude": "-89.3111995",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 601-582-7148",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dda-0e10-76b8-a750-0dc4c103e940.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-0e10-76b8-a750-0dc4c103e940",
        "storage_key": "property/6737460151192644/019e1dda-0e10-76b8-a750-0dc4c103e940.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT2hikTzcnIgR8P1Rfls5W1w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewpub"
    },
    {
      "id": "custom_efd25ed5-7d69-41b8-b657-118018f90fe3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Sully's Hattiesburg",
      "poi_type": "Restaurants",
      "poi_address": "213 Sullivan Kilrain Rd, Hattiesburg, MS 39402, USA",
      "poi_short_description": "Bar that dispenses steaks along with seafood, burgers, pastas, and more. Friendly staff.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-c0bf-7444-8c78-ccf6b3c5307d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-c0bf-7444-8c78-ccf6b3c5307d",
        "storage_key": "property/6737460151192644/019e1dd9-c0bf-7444-8c78-ccf6b3c5307d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.ilovesullys.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5745810606680339419&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sullys-hattiesburg",
      "poi_latitude": "31.2553329",
      "poi_longitude": "-89.3385057",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 601-336-5358",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0cbf-71dc-9f12-48c766facff1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0cbf-71dc-9f12-48c766facff1",
        "storage_key": "property/6737460151192644/019e1dd9-0cbf-71dc-9f12-48c766facff1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJz_fS4KPgnIgR23Pa3U04vU8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_ad3a973a-7a38-4b75-bf1e-f28c5f3239c9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Jutamas Thai Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "910 Timothy Ln, Hattiesburg, MS 39401, USA",
      "poi_short_description": "Casual Thai eatery offering familiar rice & noodle dishes, plus traditional desserts in comfy digs.",
      "poi_long_description": "Casual Thai eatery offering familiar rice & noodle dishes, plus traditional desserts in comfy digs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-c622-7042-b644-451f2bf943ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-c622-7042-b644-451f2bf943ac",
        "storage_key": "property/6737460151192644/019e1dd9-c622-7042-b644-451f2bf943ac.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://jutamasthaims.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1543164808134269776&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jutamas-thai-restaurant",
      "poi_latitude": "31.3127937",
      "poi_longitude": "-89.3074951",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 601-584-8583",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0cbf-71dc-9f12-48c766facff1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0cbf-71dc-9f12-48c766facff1",
        "storage_key": "property/6737460151192644/019e1dd9-0cbf-71dc-9f12-48c766facff1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJvc0KrzbcnIgRUBu6ijdsahU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "custom_cf9d32b2-d096-4f79-9802-1320c4fa8d20",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Petra Cafe Greek & Mediterranean",
      "poi_type": "Restaurants",
      "poi_address": "6060 US 49, Hattiesburg, MS 39401, USA",
      "poi_short_description": "Gyros, kebabs & other Mediterranean & Middle Eastern specialties served in laid-back surroundings.",
      "poi_long_description": "Gyros, kebabs & other Mediterranean & Middle Eastern specialties served in laid-back surroundings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-c382-75ba-8818-c2577173616f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-c382-75ba-8818-c2577173616f",
        "storage_key": "property/6737460151192644/019e1dd9-c382-75ba-8818-c2577173616f.webp",
        "width": 1280,
        "height": 688
      },
      "poi_business_url": "https://petracafe.net/?y_source=1_NjIzNjk1MjgtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=3079223664834402521&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "petra-cafe-greek--mediterranean",
      "poi_latitude": "31.31913519999999",
      "poi_longitude": "-89.32757319999999",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 601-268-8850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0cbf-71dc-9f12-48c766facff1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0cbf-71dc-9f12-48c766facff1",
        "storage_key": "property/6737460151192644/019e1dd9-0cbf-71dc-9f12-48c766facff1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1Wf7T5fenIgR2Vhu1puZuyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "custom_bbca670e-9524-4de0-aa42-ef75b198640d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Newt's Catfish Seafood & Steaks",
      "poi_type": "Restaurants",
      "poi_address": "503 Elks Lake Rd #30, Hattiesburg, MS 39401, USA",
      "poi_short_description": "Family-friendly eatery specializing in steaks and fried seafood dishes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-bdbb-72c9-80e0-da871df53aaf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-bdbb-72c9-80e0-da871df53aaf",
        "storage_key": "property/6737460151192644/019e1dd9-bdbb-72c9-80e0-da871df53aaf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://newtscatfishseafoodandsteaks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13700135594175967&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "newts-catfish-seafood--steaks",
      "poi_latitude": "31.2358836",
      "poi_longitude": "-89.3027041",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 18 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 601-543-5085",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0cbf-71dc-9f12-48c766facff1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0cbf-71dc-9f12-48c766facff1",
        "storage_key": "property/6737460151192644/019e1dd9-0cbf-71dc-9f12-48c766facff1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJo7blPRXnnIgR3y13YzOsMAA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_a216ada8-6bb9-4d5b-822d-d62a895b0f52",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Trattoria Pizzeria",
      "poi_type": "Restaurants",
      "poi_address": "128 E Front St, Hattiesburg, MS 39401, USA",
      "poi_short_description": "Calzones, pizzas, and other Italian eats served in a family-friendly space with a bar and sports on TV.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-ca20-76c5-b3b2-6f1b8c88b964.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-ca20-76c5-b3b2-6f1b8c88b964",
        "storage_key": "property/6737460151192644/019e1dd9-ca20-76c5-b3b2-6f1b8c88b964.webp",
        "width": 1200,
        "height": 628
      },
      "poi_business_url": "https://trattoriapizzeriams.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2120761098479462683&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trattoria-pizzeria",
      "poi_latitude": "31.3270517",
      "poi_longitude": "-89.28928789999999",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 601-336-9222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0cbf-71dc-9f12-48c766facff1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0cbf-71dc-9f12-48c766facff1",
        "storage_key": "property/6737460151192644/019e1dd9-0cbf-71dc-9f12-48c766facff1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6dkibivdnIgRG-lVmPt0bh0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_742a34c5-77c8-4847-88b7-2bac7268544f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Mercury Pizza Company Midtown",
      "poi_type": "Restaurants",
      "poi_address": "3805 W 4th St, Hattiesburg, MS 39401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-cb52-75e5-aee0-45522fb7d876.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-cb52-75e5-aee0-45522fb7d876",
        "storage_key": "property/6737460151192644/019e1dd9-cb52-75e5-aee0-45522fb7d876.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12942273213805782169&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mercury-pizza-company-midtown",
      "poi_latitude": "31.3358383",
      "poi_longitude": "-89.345906",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 601-336-5401",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0cbf-71dc-9f12-48c766facff1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0cbf-71dc-9f12-48c766facff1",
        "storage_key": "property/6737460151192644/019e1dd9-0cbf-71dc-9f12-48c766facff1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ17XeLeXfnIgRmWTytuownLM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_a09fc88f-9905-4af3-b198-89eec7899d7b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Mugshots Grill and Bar - Hattiesburg, MS",
      "poi_type": "Restaurants",
      "poi_address": "204 N 40th Ave, Hattiesburg, MS 39401, USA",
      "poi_short_description": "Convivial spot for burgers, sandwiches & salads, some with a Hawaiian twist, plus beer.",
      "poi_long_description": "Convivial spot for burgers, sandwiches & salads, some with a Hawaiian twist, plus beer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-cdaf-7719-9ebd-5503852d4d6b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-cdaf-7719-9ebd-5503852d4d6b",
        "storage_key": "property/6737460151192644/019e1dd9-cdaf-7719-9ebd-5503852d4d6b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.mugshotsgrillandbar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13503850629797873508&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mugshots-grill-and-bar---hattiesburg-ms",
      "poi_latitude": "31.3278916",
      "poi_longitude": "-89.34843029999999",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 601-271-2299",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0cbf-71dc-9f12-48c766facff1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0cbf-71dc-9f12-48c766facff1",
        "storage_key": "property/6737460151192644/019e1dd9-0cbf-71dc-9f12-48c766facff1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1389NcHenIgRZIcJ8ZlQZ7s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_cd9b02a4-6a09-4e68-9d11-c188d831117e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Hattiesburgers and Blues",
      "poi_type": "Restaurants",
      "poi_address": "142 E Front St, Hattiesburg, MS 39401, USA",
      "poi_short_description": "Casual American restaurant offering gourmet burgers, craft beer, and live music.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-cce7-7532-85b9-216591085160.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-cce7-7532-85b9-216591085160",
        "storage_key": "property/6737460151192644/019e1dd9-cce7-7532-85b9-216591085160.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hattiesburgersandblues.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2110650124105417205&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hattiesburgers-and-blues",
      "poi_latitude": "31.3272452",
      "poi_longitude": "-89.28886829999999",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 601-520-2674",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0cbf-71dc-9f12-48c766facff1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0cbf-71dc-9f12-48c766facff1",
        "storage_key": "property/6737460151192644/019e1dd9-0cbf-71dc-9f12-48c766facff1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJB8iVi0fdnIgR9QFw7BqJSh0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_701adb78-7b82-4220-86ca-10b38f9d911a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "2507 Hardy St, Hattiesburg, MS 39401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-cc8b-70df-8dac-a246709f7675.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-cc8b-70df-8dac-a246709f7675",
        "storage_key": "property/6737460151192644/019e1dd9-cc8b-70df-8dac-a246709f7675.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/hattiesburg-ms-pharmacies/2507-hardy-st-hattiesburg-ms-39401/storeid=3124?WT.mc_id=LS_GOOGLE_RX_3124",
      "poi_directions_map_url": "https://maps.google.com/?cid=6760436755626423339&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "31.3252021",
      "poi_longitude": "-89.32820860000001",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 601-544-2545",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dda-0db8-74d9-ae73-b0e78ca8b0c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-0db8-74d9-ae73-b0e78ca8b0c3",
        "storage_key": "property/6737460151192644/019e1dda-0db8-74d9-ae73-b0e78ca8b0c3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJse1lR5nenIgRK3SbMWnl0V0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_cccd1b88-6e2d-457d-a038-f66aa3d0542a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "6130 US 49, Hattiesburg, MS 39401, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-d00d-75ba-8939-b30e03ac9073.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-d00d-75ba-8939-b30e03ac9073",
        "storage_key": "property/6737460151192644/019e1dd9-d00d-75ba-8939-b30e03ac9073.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-6130+u+s+highway+49-hattiesburg-ms-39401/id=5307",
      "poi_directions_map_url": "https://maps.google.com/?cid=7063563278926124711&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "31.3242425",
      "poi_longitude": "-89.3281442",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 601-545-6959",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0de8-77c8-8b33-34148810ff7f",
        "storage_key": "property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1wVaWpnenIgRp5biuGDRBmI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_de853a76-260d-4578-a416-a1b8b207ab6f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Sullivan's Grocery",
      "poi_type": "Shopping & Retail",
      "poi_address": "810 James St, Hattiesburg, MS 39401, USA",
      "poi_short_description": "Friendly store featuring a selection of fresh meat and other grocery items.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-d1d8-7608-b506-8c7aeb8ddd2a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-d1d8-7608-b506-8c7aeb8ddd2a",
        "storage_key": "property/6737460151192644/019e1dd9-d1d8-7608-b506-8c7aeb8ddd2a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://sullivansgroc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4256370564661844835&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sullivans-grocery",
      "poi_latitude": "31.3167894",
      "poi_longitude": "-89.2844432",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 601-583-3441",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0d5d-701d-baad-c3ceef1c917a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0d5d-701d-baad-c3ceef1c917a",
        "storage_key": "property/6737460151192644/019e1dd9-0d5d-701d-baad-c3ceef1c917a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI9QeCfjcnIgRYxsZM3qqETs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_54a6b78a-d26a-460f-a12b-adb37407bef1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "CITGO FOOD MART",
      "poi_type": "Shopping & Retail",
      "poi_address": "901 Hardy St, Hattiesburg, MS 39401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-d27b-7418-b067-989a659a95f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-d27b-7418-b067-989a659a95f7",
        "storage_key": "property/6737460151192644/019e1dd9-d27b-7418-b067-989a659a95f7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.citgo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2845206596560816718&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "citgo-food-mart",
      "poi_latitude": "31.3250286",
      "poi_longitude": "-89.30440569999999",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 601-544-0825",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dda-0dad-724c-ad02-a8e0f7907fcb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-0dad-724c-ad02-a8e0f7907fcb",
        "storage_key": "property/6737460151192644/019e1dda-0dad-724c-ad02-a8e0f7907fcb.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJSTpPXT_cnIgRTgqbNFM0fCc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_a8dde6d4-3ebd-4ce3-87e7-facab0b6e4b8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Minit Mart",
      "poi_type": "Shopping & Retail",
      "poi_address": "1801 Hardy St, Hattiesburg, MS 39401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4828277263191169592&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "minit-mart",
      "poi_latitude": "31.3250635",
      "poi_longitude": "-89.31689589999999",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 601-583-2992",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dda-0dad-724c-ad02-a8e0f7907fcb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-0dad-724c-ad02-a8e0f7907fcb",
        "storage_key": "property/6737460151192644/019e1dda-0dad-724c-ad02-a8e0f7907fcb.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJ6UL66iPcnIgRONqa7ZZ8AUM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_83f5e4b7-28d4-4bbe-8ee5-885014c90ca4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Brothers Food Mart- Citgo",
      "poi_type": "Shopping & Retail",
      "poi_address": "801 James St, Hattiesburg, MS 39401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-d705-753f-8177-c7988c2a1319.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-d705-753f-8177-c7988c2a1319",
        "storage_key": "property/6737460151192644/019e1dd9-d705-753f-8177-c7988c2a1319.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.citgo.com/station-locator?search=801+James+Street,+Hattiesburg,+Mississippi+39401,+United+States",
      "poi_directions_map_url": "https://maps.google.com/?cid=274138449051559197&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brothers-food-mart--citgo",
      "poi_latitude": "31.3160879",
      "poi_longitude": "-89.28479019999999",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 601-544-4675",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dda-0dc0-70ce-bc55-08e70bb7b0a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-0dc0-70ce-bc55-08e70bb7b0a2",
        "storage_key": "property/6737460151192644/019e1dda-0dc0-70ce-bc55-08e70bb7b0a2.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJpUYm3lfcnIgRHaX-infvzQM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_415437f3-1cc0-4a66-94f2-715870b1eb9a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Corner Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "1900 Hardy St, Hattiesburg, MS 39401, USA",
      "poi_short_description": "Grocery store inside Hardy Street Mart Shopping Center with produce and a deli.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-d44b-724a-817e-36eca4d2aedf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-d44b-724a-817e-36eca4d2aedf",
        "storage_key": "property/6737460151192644/019e1dd9-d44b-724a-817e-36eca4d2aedf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cornermarketms.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7268512026289469105&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "corner-market",
      "poi_latitude": "31.3242285",
      "poi_longitude": "-89.31940949999999",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 601-545-1741",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0d5d-701d-baad-c3ceef1c917a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0d5d-701d-baad-c3ceef1c917a",
        "storage_key": "property/6737460151192644/019e1dd9-0d5d-701d-baad-c3ceef1c917a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFXi_SSHcnIgRsXajfC3x3mQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_1dd00587-ac58-405a-bcd6-88410106bfa2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Winn-Dixie",
      "poi_type": "Shopping & Retail",
      "poi_address": "4400 Hardy St, Hattiesburg, MS 39402, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-d2d0-73be-a621-ec4736aaa950.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-d2d0-73be-a621-ec4736aaa950",
        "storage_key": "property/6737460151192644/019e1dd9-d2d0-73be-a621-ec4736aaa950.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.winndixie.com/StoreDetails?search=2626",
      "poi_directions_map_url": "https://maps.google.com/?cid=4825743055223273557&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "winn-dixie",
      "poi_latitude": "31.322832",
      "poi_longitude": "-89.3542421",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 601-268-1683",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0d5d-701d-baad-c3ceef1c917a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0d5d-701d-baad-c3ceef1c917a",
        "storage_key": "property/6737460151192644/019e1dd9-0d5d-701d-baad-c3ceef1c917a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ8D8lhDfnIgRVTjkp717-EI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_85e5e04a-3f23-41e2-b8c1-9dfb5ab83175",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "5901 US 49, Hattiesburg, MS 39402, USA",
      "poi_short_description": "Retail chain offering groceries and household essentials, plus a pharmacy.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-d5d6-76ac-b532-3122c20a4eb7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-d5d6-76ac-b532-3122c20a4eb7",
        "storage_key": "property/6737460151192644/019e1dd9-d5d6-76ac-b532-3122c20a4eb7.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/2717-hattiesburg-ms/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=16340460096972757815&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "31.308406",
      "poi_longitude": "-89.32127799999999",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 601-296-6855",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0cf3-710f-85d4-4b273f34a987.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0cf3-710f-85d4-4b273f34a987",
        "storage_key": "property/6737460151192644/019e1dd9-0cf3-710f-85d4-4b273f34a987.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJo3045CrcnIgRN5uB-uH5xOI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_6961105e-d317-49f2-929a-9594c12301b9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Family Dollar",
      "poi_type": "Shopping & Retail",
      "poi_address": "3814 W 4th St. Ste 40",
      "poi_short_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_long_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-d373-72be-bf2d-5f0b532a9d53.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-d373-72be-bf2d-5f0b532a9d53",
        "storage_key": "property/6737460151192644/019e1dd9-d373-72be-bf2d-5f0b532a9d53.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://locations.familydollar.com/ms/hattiesburg/1301-edwards-st?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=9073961439933459294&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "family-dollar",
      "poi_latitude": "31.3072784",
      "poi_longitude": "-89.285553",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "30",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 769-390-8208",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0cf3-710f-85d4-4b273f34a987.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0cf3-710f-85d4-4b273f34a987",
        "storage_key": "property/6737460151192644/019e1dd9-0cf3-710f-85d4-4b273f34a987.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJvRGJpm7cnIgRXmvTjNov7X0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_c9ab37b6-50d1-44e8-90bd-75e9ae8fb508",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Thames Elementary School",
      "poi_type": "Education",
      "poi_address": "2900 Jamestown Rd, Hattiesburg, MS 39401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://thames.hattiesburgpsd.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18273367889798619173&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "thames-elementary-school",
      "poi_latitude": "31.3126902",
      "poi_longitude": "-89.3367749",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 601-582-6655",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0d0b-712b-b4dc-4524462798f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0d0b-712b-b4dc-4524462798f2",
        "storage_key": "property/6737460151192644/019e1dd9-0d0b-712b-b4dc-4524462798f2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJu0wwEIzenIgRJeB5gUcLmP0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_84c2414e-925e-469d-a586-338fc462e016",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "F.B. Woodley Elementary School",
      "poi_type": "Education",
      "poi_address": "2006 O'Ferral St, Hattiesburg, MS 39401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://woodley.hattiesburgpsd.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13061738104302810708&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fb-woodley-elementary-school",
      "poi_latitude": "31.3221768",
      "poi_longitude": "-89.3216576",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 601-583-8112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0d0b-712b-b4dc-4524462798f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0d0b-712b-b4dc-4524462798f2",
        "storage_key": "property/6737460151192644/019e1dd9-0d0b-712b-b4dc-4524462798f2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvbyQJCfcnIgRVDYnEJqdRLU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_3611c083-eeb2-41c8-abcc-7e8a7a6b669f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "NR Burger Middle School",
      "poi_type": "Education",
      "poi_address": "174 W.S.F. Tatum Blvd, Hattiesburg, MS 39401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://burger.hattiesburgpsd.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12768945037769020560&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nr-burger-middle-school",
      "poi_latitude": "31.29609099999999",
      "poi_longitude": "-89.29487209999999",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 601-582-0536",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0d0b-712b-b4dc-4524462798f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0d0b-712b-b4dc-4524462798f2",
        "storage_key": "property/6737460151192644/019e1dd9-0d0b-712b-b4dc-4524462798f2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJF55QTNvdnIgRkJS17NtnNLE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_04ded29a-271c-46c2-a4e0-f4e98d9d8905",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Hattiesburg High School",
      "poi_type": "Education",
      "poi_address": "301 N Hutchinson Ave, Hattiesburg, MS 39401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://hhs.hattiesburgpsd.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4327277687398606674&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hattiesburg-high-school",
      "poi_latitude": "31.3287229",
      "poi_longitude": "-89.3090539",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 601-544-0811",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0d0b-712b-b4dc-4524462798f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0d0b-712b-b4dc-4524462798f2",
        "storage_key": "property/6737460151192644/019e1dd9-0d0b-712b-b4dc-4524462798f2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ2wD-Kj7cnIgRUifeOSGUDTw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_be9304ce-1cbf-40ad-8c66-ea252435e7c7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Presbyterian Christian Elementary School",
      "poi_type": "Education",
      "poi_address": "103 W.S.F. Tatum Blvd, Hattiesburg, MS 39401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-d9a4-72cb-9781-273f45fbe237.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-d9a4-72cb-9781-273f45fbe237",
        "storage_key": "property/6737460151192644/019e1dd9-d9a4-72cb-9781-273f45fbe237.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.pcsk12.org",
      "poi_directions_map_url": "https://maps.google.com/?cid=16403882038467626108&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "presbyterian-christian-elementary-school",
      "poi_latitude": "31.2890665",
      "poi_longitude": "-89.3140959",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 601-268-3867",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0d0b-712b-b4dc-4524462798f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0d0b-712b-b4dc-4524462798f2",
        "storage_key": "property/6737460151192644/019e1dd9-0d0b-712b-b4dc-4524462798f2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJs-tXotzdnIgRfARGcM1LpuM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_063a929d-2cdc-41b5-a1a8-13d5787e0d33",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Sacred Heart Catholic School - Elementary Campus & Gymnasium",
      "poi_type": "Education",
      "poi_address": "608 Southern Ave, Hattiesburg, MS 39401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-d831-7513-8a54-f105db721e79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-d831-7513-8a54-f105db721e79",
        "storage_key": "property/6737460151192644/019e1dd9-d831-7513-8a54-f105db721e79.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "http://www.shshattiesburg.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2665852399451226317&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sacred-heart-catholic-school---elementary-campus--gymnasium",
      "poi_latitude": "31.3223028",
      "poi_longitude": "-89.2884624",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 601-583-8683",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0d0b-712b-b4dc-4524462798f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0d0b-712b-b4dc-4524462798f2",
        "storage_key": "property/6737460151192644/019e1dd9-0d0b-712b-b4dc-4524462798f2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVzK8aVncnIgRzcDpDKIC_yQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_ae194e89-cfb9-402f-bd0a-cbd5bdf4275e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Pearl River Community College",
      "poi_type": "Education",
      "poi_address": "5448 US 49, Hattiesburg, MS 39401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://prcc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5167714937955557062&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pearl-river-community-college",
      "poi_latitude": "31.2869323",
      "poi_longitude": "-89.2962406",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 601-554-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0d0b-712b-b4dc-4524462798f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0d0b-712b-b4dc-4524462798f2",
        "storage_key": "property/6737460151192644/019e1dd9-0d0b-712b-b4dc-4524462798f2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIym-Ab3dnIgRxh5SOVtpt0c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_a87a1ebd-4d8c-4088-b34c-2c576563e243",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Angel Academy",
      "poi_type": "Education",
      "poi_address": "21 Rivers Dr Suite 20, Hattiesburg, MS 39401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-dc1c-74ec-8475-65919fbe46a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-dc1c-74ec-8475-65919fbe46a7",
        "storage_key": "property/6737460151192644/019e1dd9-dc1c-74ec-8475-65919fbe46a7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://angelacademylearners.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6320568274113846623&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "angel-academy",
      "poi_latitude": "31.35780219999999",
      "poi_longitude": "-89.2964106",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 601-545-7322",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0d0b-712b-b4dc-4524462798f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0d0b-712b-b4dc-4524462798f2",
        "storage_key": "property/6737460151192644/019e1dd9-0d0b-712b-b4dc-4524462798f2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6chyjLfnnIgRX90ohVsrt1c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_bdcd9756-68e3-43ca-9071-25f38194db0a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Hattiesburg Saenger Theater",
      "poi_type": "Entertainment",
      "poi_address": "201 Forrest St, Hattiesburg, MS 39401, USA",
      "poi_short_description": "Historic circa-1929 movie theater hosts live events & films in neoclassical & art deco-style digs.",
      "poi_long_description": "Historic circa-1929 movie theater hosts live events & films in neoclassical & art deco-style digs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-dcf3-733a-925c-c25b6ac38245.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-dcf3-733a-925c-c25b6ac38245",
        "storage_key": "property/6737460151192644/019e1dd9-dcf3-733a-925c-c25b6ac38245.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://hattiesburgsaenger.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7082537416942817272&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hattiesburg-saenger-theater",
      "poi_latitude": "31.3260593",
      "poi_longitude": "-89.2904205",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 601-584-4888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0de8-77c8-8b33-34148810ff7f",
        "storage_key": "property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOTh5OFzcnIgR-A9KfUE6SmI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_ea787c10-4e35-4fc6-8e39-9e6b8d73a12b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Hattiesburg Pocket Museum",
      "poi_type": "Entertainment",
      "poi_address": "Downtown, 119 W Front St, Hattiesburg, MS 39401, USA",
      "poi_short_description": "Family-friendly attraction featuring a collection of creative miniature exhibits.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd8-7719-7613-979a-a5a1e4f76807.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd8-7719-7613-979a-a5a1e4f76807",
        "storage_key": "property/6737460151192644/019e1dd8-7719-7613-979a-a5a1e4f76807.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://hattiesburgpocketmuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10642009136543830328&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hattiesburg-pocket-museum",
      "poi_latitude": "31.3264026",
      "poi_longitude": "-89.2903781",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0d18-70a9-8ba1-ed30c4f0fe44.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0d18-70a9-8ba1-ed30c4f0fe44",
        "storage_key": "property/6737460151192644/019e1dd9-0d18-70a9-8ba1-ed30c4f0fe44.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2wdviOPdnIgROBEoCO0CsJM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_77a1263a-3dad-480c-a838-63328d021ec0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "T-Bones Records & Cafe",
      "poi_type": "Entertainment",
      "poi_address": "2101 Hardy St, Hattiesburg, MS 39401, USA",
      "poi_short_description": "Relaxed record store & cafe for classic vinyl, plus coffee, sandwiches & salads.",
      "poi_long_description": "Relaxed record store & cafe for classic vinyl, plus coffee, sandwiches & salads.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-de59-7240-a634-c00243c80ee3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-de59-7240-a634-c00243c80ee3",
        "storage_key": "property/6737460151192644/019e1dd9-de59-7240-a634-c00243c80ee3.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.tbonescafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13385100644127310340&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "t-bones-records--cafe",
      "poi_latitude": "31.3250836",
      "poi_longitude": "-89.3229832",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 601-583-0099",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dda-0dac-748d-8127-0b529d05736d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-0dac-748d-8127-0b529d05736d",
        "storage_key": "property/6737460151192644/019e1dda-0dac-748d-8127-0b529d05736d.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJy5HQG57enIgRBIIPWB5uwbk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_8fde35d1-a397-4240-8cae-da9e6e9ce28e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Brewsky's",
      "poi_type": "Entertainment",
      "poi_address": "3818 W 4th St, Hattiesburg, MS 39401, USA",
      "poi_short_description": "Lively, multi-venue music venue hosting live bands, DJs and cover acts, plus a patio and dance floor.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-deba-714e-9d9e-1f16e674b00f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-deba-714e-9d9e-1f16e674b00f",
        "storage_key": "property/6737460151192644/019e1dd9-deba-714e-9d9e-1f16e674b00f.webp",
        "width": 1137,
        "height": 639
      },
      "poi_business_url": "http://www.brewskyslive.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10435544352203914885&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brewskys",
      "poi_latitude": "31.3354597",
      "poi_longitude": "-89.3474717",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 601-261-2888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0de8-77c8-8b33-34148810ff7f",
        "storage_key": "property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCc86NcHenIgRhb7yZkyA0pA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_86b6da22-7078-4629-be0c-b0057e76e656",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Blu Jazz Cafe",
      "poi_type": "Entertainment",
      "poi_address": "103 E Front St, Hattiesburg, MS 39401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-cb97-75ff-8022-4efa9a0584c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-cb97-75ff-8022-4efa9a0584c3",
        "storage_key": "property/6737460151192644/019e1dd9-cb97-75ff-8022-4efa9a0584c3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.blu-jazz.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16657084117357560790&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blu-jazz-cafe",
      "poi_latitude": "31.3264518",
      "poi_longitude": "-89.2892816",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 601-402-1464",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0cbf-71dc-9f12-48c766facff1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0cbf-71dc-9f12-48c766facff1",
        "storage_key": "property/6737460151192644/019e1dd9-0cbf-71dc-9f12-48c766facff1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9ba5el7cnIgR1gPmcMDZKec",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fine_dining_restaurant"
    },
    {
      "id": "custom_62866a16-a4cd-485c-a6a6-5ee2eeeaa878",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "The Porter Public House",
      "poi_type": "Entertainment",
      "poi_address": "201 W Pine St, Hattiesburg, MS 39401, USA",
      "poi_short_description": "Laid-back eatery serving Southern, bar-food staples, burgers, meatloaf, craft beer and cocktails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-e050-766d-be6b-7919e1f9c1b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-e050-766d-be6b-7919e1f9c1b1",
        "storage_key": "property/6737460151192644/019e1dd9-e050-766d-be6b-7919e1f9c1b1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://theporterpub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10977033331206331082&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-porter-public-house",
      "poi_latitude": "31.326365",
      "poi_longitude": "-89.29146399999999",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 601-336-9373",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0cbf-71dc-9f12-48c766facff1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0cbf-71dc-9f12-48c766facff1",
        "storage_key": "property/6737460151192644/019e1dd9-0cbf-71dc-9f12-48c766facff1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJu70TU1zcnIgRyhot6qdBVpg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_d306204c-4564-441a-93c6-c5bc4cdd1dad",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Southwest Theaters Turtle Creek 9",
      "poi_type": "Entertainment",
      "poi_address": "1000 Turtle Creek Dr Suite A5, Hattiesburg, MS 39402, USA",
      "poi_short_description": "Standard multi-screen movie theater in a shopping mall with reclining seats.",
      "poi_long_description": "Standard multi-screen movie theater in a shopping mall with reclining seats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-e1f4-7409-bb82-fa9df57e4ea7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-e1f4-7409-bb82-fa9df57e4ea7",
        "storage_key": "property/6737460151192644/019e1dd9-e1f4-7409-bb82-fa9df57e4ea7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.southwesttheaters.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5851276864401626686&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southwest-theaters-turtle-creek-9",
      "poi_latitude": "31.3269699",
      "poi_longitude": "-89.3768267",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 601-909-2303",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dda-0e04-7454-a60d-99c13b84b7fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-0e04-7454-a60d-99c13b84b7fb",
        "storage_key": "property/6737460151192644/019e1dda-0e04-7454-a60d-99c13b84b7fb.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJJVNr6RPfnIgRPtYeiU7pM1E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_fa431eb0-139a-4941-bb5f-e06d1c5f612d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Hattiesburg Zoo",
      "poi_type": "Entertainment",
      "poi_address": "107 S 17th Ave, Hattiesburg, MS 39401, USA",
      "poi_short_description": "Zoo in Kamper Park with a carousel, trains & activities showcases over 75 global animal species.",
      "poi_long_description": "Zoo in Kamper Park with a carousel, trains & activities showcases over 75 global animal species.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd8-4a0d-733a-a20a-a5d231fff5de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd8-4a0d-733a-a20a-a5d231fff5de",
        "storage_key": "property/6737460151192644/019e1dd8-4a0d-733a-a20a-a5d231fff5de.webp",
        "width": 960,
        "height": 355
      },
      "poi_business_url": "http://www.hattiesburgzoo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11076613462402067942&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hattiesburg-zoo",
      "poi_latitude": "31.3226596",
      "poi_longitude": "-89.3150027",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 601-545-4576",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0de8-77c8-8b33-34148810ff7f",
        "storage_key": "property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmSsgaCPcnIgR5u3I9EEJuJk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_f2f7c7bf-bddd-46ba-98b3-e483b41c17cf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "African American Military History Museum",
      "poi_type": "Entertainment",
      "poi_address": "305 E 6th St, Hattiesburg, MS 39401, USA",
      "poi_short_description": "Museum in a former USO club focused on the history of African American military contributions.",
      "poi_long_description": "Museum in a former USO club focused on the history of African American military contributions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-e55b-714c-b902-635bb44a916f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-e55b-714c-b902-635bb44a916f",
        "storage_key": "property/6737460151192644/019e1dd9-e55b-714c-b902-635bb44a916f.webp",
        "width": 1280,
        "height": 800
      },
      "poi_business_url": "http://www.hattiesburguso.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17437843070216361562&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "african-american-military-history-museum",
      "poi_latitude": "31.3340801",
      "poi_longitude": "-89.2926954",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 601-450-1942",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0d18-70a9-8ba1-ed30c4f0fe44.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0d18-70a9-8ba1-ed30c4f0fe44",
        "storage_key": "property/6737460151192644/019e1dd9-0d18-70a9-8ba1-ed30c4f0fe44.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJqdy6cWbcnIgRWtZA-eGp__E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "history_museum"
    },
    {
      "id": "custom_042c8260-6b8b-4fac-8daa-2d06a72b397c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Hub Lanes",
      "poi_type": "Entertainment",
      "poi_address": "7022 US 49, Hattiesburg, MS 39402, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-e491-74dc-b078-3160fc3b17fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-e491-74dc-b078-3160fc3b17fa",
        "storage_key": "property/6737460151192644/019e1dd9-e491-74dc-b078-3160fc3b17fa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.facebook.com/hub.lanes/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17240728006901169075&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hub-lanes",
      "poi_latitude": "31.3770733",
      "poi_longitude": "-89.36269709999999",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 601-268-2101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0de8-77c8-8b33-34148810ff7f",
        "storage_key": "property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRxClIQDZnIgRs_t46MZeQ-8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "custom_6525e75b-f114-4ea9-9fd3-86eb456438df",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Hattiesburg Clinic Immediate Care",
      "poi_type": "Health and Wellness",
      "poi_address": "105 Thornhill Dr, Hattiesburg, MS 39402, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-e1e5-76c8-a957-ba3fa8eb726e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-e1e5-76c8-a957-ba3fa8eb726e",
        "storage_key": "property/6737460151192644/019e1dd9-e1e5-76c8-a957-ba3fa8eb726e.webp",
        "width": 1280,
        "height": 383
      },
      "poi_business_url": "https://www.hattiesburgclinic.com/locations/urgent-care/hattiesburg-105-thornhill-dr/",
      "poi_directions_map_url": "https://maps.google.com/?cid=916366127913017212&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hattiesburg-clinic-immediate-care",
      "poi_latitude": "31.3254994",
      "poi_longitude": "-89.3487798",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 601-261-3737",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0de8-77c8-8b33-34148810ff7f",
        "storage_key": "property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKwy3PenenIgRfJ90YiOWtww",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_8f676fb5-b06c-450a-a218-2f0c3f10f9c1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Hattiesburg Clinic Children's Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "4210 Lincoln Rd, Hattiesburg, MS 39402, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-e4b0-729d-9ca1-18a7fb416103.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-e4b0-729d-9ca1-18a7fb416103",
        "storage_key": "property/6737460151192644/019e1dd9-e4b0-729d-9ca1-18a7fb416103.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hattiesburgclinic.com/locations/pediatric/hattiesburg-4210-lincoln-rd/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15752461580551529165&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hattiesburg-clinic-childrens-clinic",
      "poi_latitude": "31.3020817",
      "poi_longitude": "-89.3633859",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 601-261-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0de8-77c8-8b33-34148810ff7f",
        "storage_key": "property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy7DL4o_enIgRzSLD7lj8m9o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_5a4ecd01-faef-47a7-91b6-1d85ce3ad026",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "2507 Hardy St, Hattiesburg, MS 39401, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-e702-76ec-825a-56a9530c811a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-e702-76ec-825a-56a9530c811a",
        "storage_key": "property/6737460151192644/019e1dd9-e702-76ec-825a-56a9530c811a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cvs.com/store-locator/hattiesburg-ms-pharmacies/2507-hardy-st-hattiesburg-ms-39401/storeid=3124?WT.mc_id=LS_GOOGLE_FS_3124",
      "poi_directions_map_url": "https://maps.google.com/?cid=6018264672623290720&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "31.3252021",
      "poi_longitude": "-89.32820860000001",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 601-544-2545",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0de8-77c8-8b33-34148810ff7f",
        "storage_key": "property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY8kbR5nenIgRYGn-Z9UrhVM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_35e16cef-0942-4c81-954a-76e6ee261bd8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "6130 US 49, Hattiesburg, MS 39401, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-e96b-72cf-a1a1-34cac559da4d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-e96b-72cf-a1a1-34cac559da4d",
        "storage_key": "property/6737460151192644/019e1dd9-e96b-72cf-a1a1-34cac559da4d.webp",
        "width": 1280,
        "height": 584
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-6130+u+s+highway+49-hattiesburg-ms-39401/id=5307",
      "poi_directions_map_url": "https://maps.google.com/?cid=7988201716245918555&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "31.3242005",
      "poi_longitude": "-89.3282007",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 601-545-6959",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dda-0db8-74d9-ae73-b0e78ca8b0c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-0db8-74d9-ae73-b0e78ca8b0c3",
        "storage_key": "property/6737460151192644/019e1dda-0db8-74d9-ae73-b0e78ca8b0c3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9fHOW5nenIgRW_MAOyPL224",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_e0868cf6-73bf-4183-a9e5-82a087b9bf0b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "6072 US-98, Hattiesburg, MS 39402, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-e900-737f-871f-1a54f6afc321.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-e900-737f-871f-1a54f6afc321",
        "storage_key": "property/6737460151192644/019e1dd9-e900-737f-871f-1a54f6afc321.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walmart.com/store/916-hattiesburg-ms/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=3307812439638663165&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "31.3185042",
      "poi_longitude": "-89.3794661",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 601-264-3631",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dda-0db8-74d9-ae73-b0e78ca8b0c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-0db8-74d9-ae73-b0e78ca8b0c3",
        "storage_key": "property/6737460151192644/019e1dda-0db8-74d9-ae73-b0e78ca8b0c3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeXF-O8ognYgR_d9HaOO15y0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_7373d760-de39-4f65-9e65-86225c186354",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "6128 US 49, Hattiesburg, MS 39401, USA",
      "poi_short_description": "Gym chain featuring cardio and weight machines, plus hydromassage and tanning services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd8-9fbd-77b8-a5dc-2ebe71fe5364.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd8-9fbd-77b8-a5dc-2ebe71fe5364",
        "storage_key": "property/6737460151192644/019e1dd8-9fbd-77b8-a5dc-2ebe71fe5364.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/hattiesburg-ms?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=17569956349361842124&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "31.3236576",
      "poi_longitude": "-89.3284932",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 601-602-4721",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0de8-77c8-8b33-34148810ff7f",
        "storage_key": "property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwzkeZJnenIgRzOfUyjUG1fM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_4b59c448-e19a-4e12-81f7-305a68edf052",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Crunch Fitness - Hattiesburg",
      "poi_type": "Health and Wellness",
      "poi_address": "4501 Hardy St Suite 50, Hattiesburg, MS 39402, USA",
      "poi_short_description": "Fitness center featuring strength training and cardio equipment as well as group classes, such as Zumba.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd8-c1b1-75c6-9a3a-44ae2224a93b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd8-c1b1-75c6-9a3a-44ae2224a93b",
        "storage_key": "property/6737460151192644/019e1dd8-c1b1-75c6-9a3a-44ae2224a93b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.crunch.com/locations/hattiesburg",
      "poi_directions_map_url": "https://maps.google.com/?cid=117593124365209967&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crunch-fitness---hattiesburg",
      "poi_latitude": "31.3271999",
      "poi_longitude": "-89.3581924",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 601-336-5322",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0de8-77c8-8b33-34148810ff7f",
        "storage_key": "property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe8Sx5ODenIgRbxHR1VLGoQE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_13438ab0-dd32-4909-90e3-cee7add49d38",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "109 S 31st Ave #10, Hattiesburg, MS 39401, USA",
      "poi_short_description": "Fitness classes incorporating cardio and strength training in a group setting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-f520-7769-a1a6-381034ab8ca1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-f520-7769-a1a6-381034ab8ca1",
        "storage_key": "property/6737460151192644/019e1dd9-f520-7769-a1a6-381034ab8ca1.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/hattiesburg-mississippi-0995?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=2998811975160465691&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "31.3239411",
      "poi_longitude": "-89.33580930000001",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 601-651-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0de8-77c8-8b33-34148810ff7f",
        "storage_key": "property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj3aEh0LfnIgRG4mgX5rrnSk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_772c5e62-22be-49b3-8e53-b3f5cbc53fe0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Greenhouse Yoga",
      "poi_type": "Health and Wellness",
      "poi_address": "208 S 25th Ave, Hattiesburg, MS 39401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13963324276029783187&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greenhouse-yoga",
      "poi_latitude": "31.3220593",
      "poi_longitude": "-89.32748699999999",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 601-909-5171",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0d0b-712b-b4dc-4524462798f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0d0b-712b-b4dc-4524462798f2",
        "storage_key": "property/6737460151192644/019e1dd9-0d0b-712b-b4dc-4524462798f2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJB5XUdZzenIgRk_xXvHKxx8E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_d012dc74-e0ff-417e-88fd-ea8f08d66431",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Fairchild Leisure Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "951 Beverly Hills Rd, Hattiesburg, MS 39401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-edff-777b-a6b4-a061459defb7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-edff-777b-a6b4-a061459defb7",
        "storage_key": "property/6737460151192644/019e1dd9-edff-777b-a6b4-a061459defb7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.hattiesburgms.com/parksandrec/parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8681291480985862627&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fairchild-leisure-park",
      "poi_latitude": "31.3410113",
      "poi_longitude": "-89.344686",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0d5a-746c-a7e3-28add861d5ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0d5a-746c-a7e3-28add861d5ca",
        "storage_key": "property/6737460151192644/019e1dd9-0d5a-746c-a7e3-28add861d5ca.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ53wsv0jfnIgR44HJQ5skeng",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c05a7cfa-cb0a-4697-aa8b-ffe6c933d121",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Longleaf Trace",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2895 W 4th St, Hattiesburg, MS 39401, USA",
      "poi_short_description": "Tree-lined paved trail for biking and walking with water fountains and restrooms.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd8-e5a7-738b-9f39-49a396b838de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd8-e5a7-738b-9f39-49a396b838de",
        "storage_key": "property/6737460151192644/019e1dd8-e5a7-738b-9f39-49a396b838de.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.longleaftrace.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2877308683026320595&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "longleaf-trace",
      "poi_latitude": "31.3329978",
      "poi_longitude": "-89.3317352",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 601-450-5247",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0de8-77c8-8b33-34148810ff7f",
        "storage_key": "property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpbsW-aLenIgR00zuqABB7ic",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_d213225a-2de5-4801-a44a-0476f51663b8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Kamper Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "107 S 17th Ave, Hattiesburg, MS 39401, USA",
      "poi_short_description": "This 40-acre park is home to the Hattiesburg Zoo, plus tennis courts, playgrounds & walking trails.",
      "poi_long_description": "This 40-acre park is home to the Hattiesburg Zoo, plus tennis courts, playgrounds & walking trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd8-e475-70c9-9937-2bca0c6e3496.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd8-e475-70c9-9937-2bca0c6e3496",
        "storage_key": "property/6737460151192644/019e1dd8-e475-70c9-9937-2bca0c6e3496.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.visithburg.org/directory/kamper-park-family-fun/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7358523558911182446&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kamper-park",
      "poi_latitude": "31.32407629999999",
      "poi_longitude": "-89.31718049999999",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 601-545-4576",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0d5a-746c-a7e3-28add861d5ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0d5a-746c-a7e3-28add861d5ca",
        "storage_key": "property/6737460151192644/019e1dd9-0d5a-746c-a7e3-28add861d5ca.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJuajQ9iPcnIgRboY-kDC6HmY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1d6b5893-9e17-45b3-9fea-9093678619bb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Duncan Lake Hattiesburg Mississippi",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "James St, Hattiesburg, MS 39401, USA",
      "poi_short_description": "Park with a lake full of geese and ducks that people love to feed.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-efa0-756d-92e4-d0863060872e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-efa0-756d-92e4-d0863060872e",
        "storage_key": "property/6737460151192644/019e1dd9-efa0-756d-92e4-d0863060872e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14209637024038644444&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "duncan-lake-hattiesburg-mississippi",
      "poi_latitude": "31.3111575",
      "poi_longitude": "-89.2790617",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0d5a-746c-a7e3-28add861d5ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0d5a-746c-a7e3-28add861d5ca",
        "storage_key": "property/6737460151192644/019e1dd9-0d5a-746c-a7e3-28add861d5ca.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkcGTzj7dnIgR3OoPZZbFMsU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_60a90f85-5c02-43d3-b5fe-2220424b24d4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Oseola McCarty Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "500 West St, Hattiesburg, MS 39401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-eed1-75aa-9c56-a54bb75ea3f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-eed1-75aa-9c56-a54bb75ea3f9",
        "storage_key": "property/6737460151192644/019e1dd9-eed1-75aa-9c56-a54bb75ea3f9.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13302268134581684518&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oseola-mccarty-park",
      "poi_latitude": "31.3295741",
      "poi_longitude": "-89.3011932",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 601-545-4624",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0d5a-746c-a7e3-28add861d5ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0d5a-746c-a7e3-28add861d5ca",
        "storage_key": "property/6737460151192644/019e1dd9-0d5a-746c-a7e3-28add861d5ca.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-yFmfmrcnIgRJkm91GMmm7g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_98bae321-9510-4ee9-bd06-50a9bdb868ee",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Tatum Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "101 Parkway Blvd, Hattiesburg, MS 39401, USA",
      "poi_short_description": "Park featuring fields for soccer, baseball and tennis, plus a disc golf course.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd8-de37-701f-a860-b4e3cb812c6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd8-de37-701f-a860-b4e3cb812c6d",
        "storage_key": "property/6737460151192644/019e1dd8-de37-701f-a860-b4e3cb812c6d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8423282603357287630&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tatum-park",
      "poi_latitude": "31.2823229",
      "poi_longitude": "-89.3166734",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0d5a-746c-a7e3-28add861d5ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0d5a-746c-a7e3-28add861d5ca",
        "storage_key": "property/6737460151192644/019e1dd9-0d5a-746c-a7e3-28add861d5ca.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ88t1d_dnIgRzrTWN-aC5XQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6eb38149-b8cd-4af0-a859-ace895ea25aa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Lake Thoreau Environmental Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "150 Lake Thoreau Rd, Hattiesburg, MS 39402, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-ef86-757e-8227-53d34db34cf3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-ef86-757e-8227-53d34db34cf3",
        "storage_key": "property/6737460151192644/019e1dd9-ef86-757e-8227-53d34db34cf3.webp",
        "width": 854,
        "height": 1280
      },
      "poi_business_url": "https://www.usm.edu/lake-thoreau-environmental-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=16388448385576663175&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-thoreau-environmental-center",
      "poi_latitude": "31.3465655",
      "poi_longitude": "-89.422321",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0de8-77c8-8b33-34148810ff7f",
        "storage_key": "property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT2sPrc4gnYgRh_geGvp2b-M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_cb0e8e1e-b958-410e-b551-d0cfe40350f7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Paul B Johnson State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "319 Geiger Lake Rd, Hattiesburg, MS 39401, USA",
      "poi_short_description": "State park with lake offers over 800 acres for camping, swimming, boating, fishing & more.",
      "poi_long_description": "State park with lake offers over 800 acres for camping, swimming, boating, fishing & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-f275-71a4-8c72-97253bfc334b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-f275-71a4-8c72-97253bfc334b",
        "storage_key": "property/6737460151192644/019e1dd9-f275-71a4-8c72-97253bfc334b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.mdwfp.com/parks-destinations/park/paul-b-johnson-state-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=1077395084129062027&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "paul-b-johnson-state-park",
      "poi_latitude": "31.1393954",
      "poi_longitude": "-89.2427393",
      "poi_miles_from_property": "17.4",
      "poi_walking_minutes": "6 hours 22 mins",
      "poi_biking_minutes": "1 hour 40 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 601-582-7721",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0d5a-746c-a7e3-28add861d5ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0d5a-746c-a7e3-28add861d5ca",
        "storage_key": "property/6737460151192644/019e1dd9-0d5a-746c-a7e3-28add861d5ca.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJiwJ-RWbvnIgRi8xD6B6t8w4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_c4cd4b49-bea1-4f0e-b8a5-9649da317469",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "See Spot Run Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "707 W Pine St, Hattiesburg, MS 39401, USA",
      "poi_short_description": "Outdoor park featuring fences and separated areas for dogs of varying sizes to run and socialize.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-f328-75d8-a7ee-7422e1738812.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-f328-75d8-a7ee-7422e1738812",
        "storage_key": "property/6737460151192644/019e1dd9-f328-75d8-a7ee-7422e1738812.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.facebook.com/runwithspot/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16474051223368507338&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "see-spot-run-dog-park",
      "poi_latitude": "31.3212832",
      "poi_longitude": "-89.2972115",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 601-545-4667",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0d5a-746c-a7e3-28add861d5ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0d5a-746c-a7e3-28add861d5ca",
        "storage_key": "property/6737460151192644/019e1dd9-0d5a-746c-a7e3-28add861d5ca.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJwZIlTkTcnIgRyh947E2Wn-Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "custom_188c7c6b-1cfa-4307-8175-96e5eb1406ff",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Chain Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5619 Hwy 42, Hattiesburg, MS 39401, USA",
      "poi_short_description": "Expansive park featuring a playground, along with hiking and walking trails. Plus a river view and fishing.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-f820-777f-89e7-63593e974179.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-f820-777f-89e7-63593e974179",
        "storage_key": "property/6737460151192644/019e1dd9-f820-777f-89e7-63593e974179.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.visithburg.org/directory/chain-park-at-twin-forks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10643282795572216022&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chain-park",
      "poi_latitude": "31.3385535",
      "poi_longitude": "-89.280576",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 601-516-0872",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0d5a-746c-a7e3-28add861d5ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0d5a-746c-a7e3-28add861d5ca",
        "storage_key": "property/6737460151192644/019e1dd9-0d5a-746c-a7e3-28add861d5ca.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJV7aX2IjcnIgR1sAb4k-JtJM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_34669180-f600-4e24-a836-875ec6a7aac2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Hattiesburg, Mississippi",
      "poi_type": "Transportation & Transit",
      "poi_address": "308 Newman St, Hattiesburg, MS 39401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd8-ed78-74a5-ab76-3af2de832be4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd8-ed78-74a5-ab76-3af2de832be4",
        "storage_key": "property/6737460151192644/019e1dd8-ed78-74a5-ab76-3af2de832be4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=HBG",
      "poi_directions_map_url": "https://maps.google.com/?cid=15576773112429800048&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hattiesburg-mississippi",
      "poi_latitude": "31.3270929",
      "poi_longitude": "-89.2864075",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0d07-7730-b72c-1c814517850b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0d07-7730-b72c-1c814517850b",
        "storage_key": "property/6737460151192644/019e1dd9-0d07-7730-b72c-1c814517850b.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-2m1pV_cnIgRcOo70Z3QK9g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_46619922-0a66-461d-8b02-84ea22a15665",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "HUB CITY TRANSIT OPERATIONS CENTER",
      "poi_type": "Transportation & Transit",
      "poi_address": "S Tipton St, Hattiesburg, MS 39401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-f3dd-704b-a30e-43de7eef44a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-f3dd-704b-a30e-43de7eef44a6",
        "storage_key": "property/6737460151192644/019e1dd9-f3dd-704b-a30e-43de7eef44a6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8581038416266604074&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hub-city-transit-operations-center",
      "poi_latitude": "31.3135112",
      "poi_longitude": "-89.2807574",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0de8-77c8-8b33-34148810ff7f",
        "storage_key": "property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ19ZvQvncnIgRKi6Nrfn4FXc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "point_of_interest"
    },
    {
      "id": "custom_7725136d-fc6a-4676-8f64-347e20acfcc0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Greyhound: Bus Stop",
      "poi_type": "Transportation & Transit",
      "poi_address": "103 Campbell Loop, Hattiesburg, MS 39401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-f69f-769f-871a-5e1041851490.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-f69f-769f-871a-5e1041851490",
        "storage_key": "property/6737460151192644/019e1dd9-f69f-769f-871a-5e1041851490.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.greyhound.com/en-us/bus-station-430276",
      "poi_directions_map_url": "https://maps.google.com/?cid=17791197279095006012&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greyhound-bus-stop",
      "poi_latitude": "31.3540472",
      "poi_longitude": "-89.3444738",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 800-231-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0de8-77c8-8b33-34148810ff7f",
        "storage_key": "property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgUmfHvLYnIgRPKNa3akH5_Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_d2314af4-1d95-47b8-9ed4-9d81f4c4293d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Hattiesburg-Laurel Regional Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1002 Terminal Dr, Moselle, MS 39459, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-f82f-72dc-b429-88825679650a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-f82f-72dc-b429-88825679650a",
        "storage_key": "property/6737460151192644/019e1dd9-f82f-72dc-b429-88825679650a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.flypib.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=471158728780221330&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hattiesburg-laurel-regional-airport",
      "poi_latitude": "31.4668847",
      "poi_longitude": "-89.3335005",
      "poi_miles_from_property": "11",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 601-545-3111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dda-0dc2-712f-9c1d-2f6249b17d6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-0dc2-712f-9c1d-2f6249b17d6a",
        "storage_key": "property/6737460151192644/019e1dda-0dc2-712f-9c1d-2f6249b17d6a.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJsQN-gTjXnIgRkgvFFV7kiQY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_3d0b9466-b56e-4ccd-9add-84c854f25023",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Shell",
      "poi_type": "Transportation & Transit",
      "poi_address": "3809 Hardy St, Hattiesburg, MS 39402, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-fdc7-72b5-896f-e94699724b78.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-fdc7-72b5-896f-e94699724b78",
        "storage_key": "property/6737460151192644/019e1dd9-fdc7-72b5-896f-e94699724b78.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://find.shell.com/us/fuel/10013471-3809-hardy-st/en_US",
      "poi_directions_map_url": "https://maps.google.com/?cid=15049505708313540386&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shell",
      "poi_latitude": "31.3252112",
      "poi_longitude": "-89.3463518",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 601-264-2883",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dda-0dc0-70ce-bc55-08e70bb7b0a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-0dc0-70ce-bc55-08e70bb7b0a2",
        "storage_key": "property/6737460151192644/019e1dda-0dc0-70ce-bc55-08e70bb7b0a2.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJt8N4X-nenIgRIvc9vbSV2tA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_8df03e5e-31e3-45cb-8f56-0606ad652246",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "The University of Southern Mississippi",
      "poi_type": "Education",
      "poi_address": "118 College Dr, Hattiesburg, MS 39406, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-dee5-74be-9055-dc369d5530c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-dee5-74be-9055-dc369d5530c0",
        "storage_key": "property/6737460151192644/019e1dd9-dee5-74be-9055-dc369d5530c0.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "https://www.usm.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13495150432802250514&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-university-of-southern-mississippi",
      "poi_latitude": "31.32933999999999",
      "poi_longitude": "-89.33359349999999",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 601-266-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0d0b-712b-b4dc-4524462798f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0d0b-712b-b4dc-4524462798f2",
        "storage_key": "property/6737460151192644/019e1dd9-0d0b-712b-b4dc-4524462798f2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ11wV3pfenIgREh-jedFnSLs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_8bc8b264-b938-4bc1-b3e9-ce914ec16c00",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "William Carey University",
      "poi_type": "Education",
      "poi_address": "710 William Carey Pkwy, Hattiesburg, MS 39401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd8-312f-73b2-a6b8-3911c47efb0a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd8-312f-73b2-a6b8-3911c47efb0a",
        "storage_key": "property/6737460151192644/019e1dd8-312f-73b2-a6b8-3911c47efb0a.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.wmcarey.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6310263836244019517&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "william-carey-university",
      "poi_latitude": "31.3039491",
      "poi_longitude": "-89.2923028",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "100",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 601-318-6051",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0d0b-712b-b4dc-4524462798f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0d0b-712b-b4dc-4524462798f2",
        "storage_key": "property/6737460151192644/019e1dd9-0d0b-712b-b4dc-4524462798f2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJXTu7zqzdnIgRPYlRnoaPklc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_4165a33a-b300-4306-a9dc-cbd7a48991f6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Forrest General Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "6051 US 49, Hattiesburg, MS 39401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd8-d0dd-7129-80fe-cdecd4f4a7fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd8-d0dd-7129-80fe-cdecd4f4a7fb",
        "storage_key": "property/6737460151192644/019e1dd8-d0dd-7129-80fe-cdecd4f4a7fb.webp",
        "width": 997,
        "height": 1280
      },
      "poi_business_url": "https://www.forrestgeneral.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12055433216854901724&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "forrest-general-hospital",
      "poi_latitude": "31.3183028",
      "poi_longitude": "-89.32939069999999",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 601-288-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0d65-70be-a190-3fdfeb64c4d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0d65-70be-a190-3fdfeb64c4d9",
        "storage_key": "property/6737460151192644/019e1dd9-0d65-70be-a190-3fdfeb64c4d9.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJk3LAOpvenIgR3MMUaKOATac",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_bcca7b30-57b7-4aa9-a1d0-5efb8cc81dd3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Hattiesburg Clinic",
      "poi_type": "Major Employers & Offices",
      "poi_address": "415 S 28th Ave, Hattiesburg, MS 39401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dda-01a1-7334-a5ee-de174e711be9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dda-01a1-7334-a5ee-de174e711be9",
        "storage_key": "property/6737460151192644/019e1dda-01a1-7334-a5ee-de174e711be9.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.hattiesburgclinic.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14069144594868981494&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hattiesburg-clinic",
      "poi_latitude": "31.3187059",
      "poi_longitude": "-89.33226839999999",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 601-264-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0de8-77c8-8b33-34148810ff7f",
        "storage_key": "property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJswEVr5renIgR9s7FrnekP8M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_923ae4b4-2d5a-4b60-9aca-b85f1d0f88eb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Camp Shelby Range Control",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Hattiesburg, MS 39401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13973029224150420692&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "camp-shelby-range-control",
      "poi_latitude": "31.1823802",
      "poi_longitude": "-89.1667945",
      "poi_miles_from_property": "17.9",
      "poi_walking_minutes": "6 hours 33 mins",
      "poi_biking_minutes": "1 hour 51 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+1 601-558-2709",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-1091-74b2-a4a4-ec3a88e69f0d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1091-74b2-a4a4-ec3a88e69f0d",
        "storage_key": "property/6737460151192644/019e1dd9-1091-74b2-a4a4-ec3a88e69f0d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJucht5lXrnIgR1EyjDQws6sE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "custom_601deebc-fde7-4047-b01b-ebb8f36314e8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Hattiesburg VA Clinic",
      "poi_type": "Major Employers & Offices",
      "poi_address": "B, 5003 Hardy St # 402, Hattiesburg, MS 39402, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dda-0059-7590-8a17-8e58e0b183e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dda-0059-7590-8a17-8e58e0b183e7",
        "storage_key": "property/6737460151192644/019e1dda-0059-7590-8a17-8e58e0b183e7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.jackson.va.gov/locations/Hattiesburg.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=9882574897360326423&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hattiesburg-va-clinic",
      "poi_latitude": "31.32625",
      "poi_longitude": "-89.36788940000001",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 601-296-3530",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0de8-77c8-8b33-34148810ff7f",
        "storage_key": "property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZwkrRhnfnIgRF89aT4L1JYk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_03cc12dd-1e92-43a8-ba07-431fdbf56553",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Forrest County Circuit Clerk's Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "630 Main St, Hattiesburg, MS 39401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-fecc-735e-8ed3-0e24f01d96d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-fecc-735e-8ed3-0e24f01d96d9",
        "storage_key": "property/6737460151192644/019e1dd9-fecc-735e-8ed3-0e24f01d96d9.webp",
        "width": 1163,
        "height": 872
      },
      "poi_business_url": "https://forrestcountyms.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12768619029105979522&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "forrest-county-circuit-clerks-office",
      "poi_latitude": "31.3272962",
      "poi_longitude": "-89.2913087",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 601-582-3213",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-1091-74b2-a4a4-ec3a88e69f0d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1091-74b2-a4a4-ec3a88e69f0d",
        "storage_key": "property/6737460151192644/019e1dd9-1091-74b2-a4a4-ec3a88e69f0d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7Wk9Ql3cnIgRgrAnHls_M7E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_9f98d42f-85a5-4802-8e40-a90b054a4836",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Hattiesburg City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "200 Forrest St, Hattiesburg, MS 39401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd8-ef4b-701d-a9ce-c25a13cda6d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd8-ef4b-701d-a9ce-c25a13cda6d9",
        "storage_key": "property/6737460151192644/019e1dd8-ef4b-701d-a9ce-c25a13cda6d9.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.hattiesburgms.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7716933684340124760&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hattiesburg-city-hall",
      "poi_latitude": "31.325566",
      "poi_longitude": "-89.29101089999999",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 601-545-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-1091-74b2-a4a4-ec3a88e69f0d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1091-74b2-a4a4-ec3a88e69f0d",
        "storage_key": "property/6737460151192644/019e1dd9-1091-74b2-a4a4-ec3a88e69f0d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdXRhRFzcnIgRWOxWwkwOGGs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_faaf73a3-c496-4b64-b268-d00699a86f97",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Hattiesburg Public School District",
      "poi_type": "Major Employers & Offices",
      "poi_address": "301 Mamie St, Hattiesburg, MS 39401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.hattiesburgpsd.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6244395906696445616&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hattiesburg-public-school-district",
      "poi_latitude": "31.3233708",
      "poi_longitude": "-89.301965",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 601-582-5078",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0d0b-712b-b4dc-4524462798f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0d0b-712b-b4dc-4524462798f2",
        "storage_key": "property/6737460151192644/019e1dd9-0d0b-712b-b4dc-4524462798f2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJm_MeO0fcnIgRsH6LL_6MqFY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_14fba96e-23ff-4bab-83e4-093d880c6ffb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Midtown Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "3720 Hardy St, Hattiesburg, MS 39402, USA",
      "poi_short_description": "Supermarket stocking meats, produce and cheese, plus seafood, cakes and sushi.",
      "poi_long_description": "People say this shopping center offers delicious food and bakery items, including huge biscuits and berry burgcake. They also highlight the great atmosphere and helpful attendants. Visitors mention the ample parking and fast wait times, even when busy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019ea8ff-f32d-7465-b28b-74f797355a3f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8ff-f32d-7465-b28b-74f797355a3f",
        "storage_key": "property/6737460151192644/019ea8ff-f32d-7465-b28b-74f797355a3f.webp",
        "width": 1280,
        "height": 562
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12061441018671727943&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "midtown-market",
      "poi_latitude": "31.323342",
      "poi_longitude": "-89.34524909999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 601-264-3425",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0cf3-710f-85d4-4b273f34a987.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0cf3-710f-85d4-4b273f34a987",
        "storage_key": "property/6737460151192644/019e1dd9-0cf3-710f-85d4-4b273f34a987.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ24LYipTfnIgRRwVBxbPYYqc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_3a475291-9ee2-4888-8aec-d24add626e41",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Turtle Creek Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "1000 Turtle Creek Dr, Hattiesburg, MS 39402, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd8-73da-715b-8b81-2cf1e1c97e96.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd8-73da-715b-8b81-2cf1e1c97e96",
        "storage_key": "property/6737460151192644/019e1dd8-73da-715b-8b81-2cf1e1c97e96.webp",
        "width": 1280,
        "height": 914
      },
      "poi_business_url": "https://www.turtlecreekmall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1761745978379246005&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "turtle-creek-mall",
      "poi_latitude": "31.3268349",
      "poi_longitude": "-89.3759815",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 601-261-3032",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0cf3-710f-85d4-4b273f34a987.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0cf3-710f-85d4-4b273f34a987",
        "storage_key": "property/6737460151192644/019e1dd9-0cf3-710f-85d4-4b273f34a987.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJO3BTOBTfnIgRtZnEGaL6chg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_91b9f3e1-e6d8-422f-96da-bb5e92cf5863",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Dollar General",
      "poi_type": "Shopping & Retail",
      "poi_address": "4899 W 4th St, Hattiesburg, MS 39402, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019ea8ff-edaa-7076-837d-ff26afcc8056.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8ff-edaa-7076-837d-ff26afcc8056",
        "storage_key": "property/6737460151192644/019ea8ff-edaa-7076-837d-ff26afcc8056.webp",
        "width": 480,
        "height": 720
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/ms/hattiesburg/6473",
      "poi_directions_map_url": "https://maps.google.com/?cid=10303116738677132616&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "31.3357365",
      "poi_longitude": "-89.3664105",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 601-336-2892",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0cf3-710f-85d4-4b273f34a987.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0cf3-710f-85d4-4b273f34a987",
        "storage_key": "property/6737460151192644/019e1dd9-0cf3-710f-85d4-4b273f34a987.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJH6xXiiPfnIgRSE076BUG_I4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_fcffcb51-151a-4b57-9155-dbf849de8c1f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "5889 US 49, Hattiesburg, MS 39402, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019ea8ff-ed9b-7157-9120-8b89f2d99e26.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8ff-ed9b-7157-9120-8b89f2d99e26",
        "storage_key": "property/6737460151192644/019ea8ff-ed9b-7157-9120-8b89f2d99e26.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://locations.dollartree.com/ms/hattiesburg/5889-highway-49?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=6179225596712554813&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "31.30676669999999",
      "poi_longitude": "-89.31939109999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 601-633-2715",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0cf3-710f-85d4-4b273f34a987.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0cf3-710f-85d4-4b273f34a987",
        "storage_key": "property/6737460151192644/019e1dd9-0cf3-710f-85d4-4b273f34a987.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJD8FEFCTZnIgRPZEN9_AEwVU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_d417c92b-dd19-46c8-b49f-48d90dfd35b5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "6042 US-98, Hattiesburg, MS 39402, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Shoppers say this supermarket offers great produce and a good selection of cheeses, with many mentioning the prices are considerably lower than other stores. They also highlight the friendly and helpful staff, and the clean and well-organized store.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd8-aa3a-777b-ab42-1c985ef5d959.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd8-aa3a-777b-ab42-1c985ef5d959",
        "storage_key": "property/6737460151192644/019e1dd8-aa3a-777b-ab42-1c985ef5d959.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://info.aldi.us/stores/l/ms/hattiesburg/6042-us-hwy-98/ff84",
      "poi_directions_map_url": "https://maps.google.com/?cid=7225490807296086301&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "31.321319",
      "poi_longitude": "-89.377693",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0d5d-701d-baad-c3ceef1c917a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0d5d-701d-baad-c3ceef1c917a",
        "storage_key": "property/6737460151192644/019e1dd9-0d5d-701d-baad-c3ceef1c917a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJewswQMrfnIgRHdG7YJsZRmQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_499a21b0-b8a6-4f55-9f88-679315b888f4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Best Buy",
      "poi_type": "Shopping & Retail",
      "poi_address": "4600 Hardy St Ste 23, Hattiesburg, MS 39402, USA",
      "poi_short_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_long_description": "People say this electronics store has friendly and helpful staff who are knowledgeable about the products, especially TVs. They also highlight the relaxed atmosphere and the staff's willingness to go the extra mile, such as carrying purchases to customers' vehicles.\n\nSome reviews mention the wait times for assistance can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019ea8ff-f059-721a-9463-d50a9c613791.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8ff-f059-721a-9463-d50a9c613791",
        "storage_key": "property/6737460151192644/019ea8ff-f059-721a-9463-d50a9c613791.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.bestbuy.com/ms/hattiesburg/4600-hardy-st-661.html/?ref=NS&loc=ns100",
      "poi_directions_map_url": "https://maps.google.com/?cid=3638676709879239552&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "best-buy",
      "poi_latitude": "31.3221555",
      "poi_longitude": "-89.35827809999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 601-296-1922",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0cf3-710f-85d4-4b273f34a987.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0cf3-710f-85d4-4b273f34a987",
        "storage_key": "property/6737460151192644/019e1dd9-0cf3-710f-85d4-4b273f34a987.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJv3vbtePenIgRgNPWaDAtfzI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "electronics_store"
    },
    {
      "id": "custom_3ebe1ed7-b285-41c4-b0a2-f3e69d1a6996",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Hobby Lobby",
      "poi_type": "Shopping & Retail",
      "poi_address": "5058 Hardy St, Hattiesburg, MS 39402, USA",
      "poi_short_description": "Chain carrying a variety of arts & crafts materials, plus party supplies, fabric & home-decor items.",
      "poi_long_description": "People say this craft store offers a wide selection of craft supplies, home decor, and seasonal decorations. They highlight the great retail prices and the friendly, knowledgeable staff. They also like the helpful service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019ea8ff-eefa-7274-9fa1-3a7b1338d854.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8ff-eefa-7274-9fa1-3a7b1338d854",
        "storage_key": "property/6737460151192644/019ea8ff-eefa-7274-9fa1-3a7b1338d854.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.hobbylobby.com/stores/search/269",
      "poi_directions_map_url": "https://maps.google.com/?cid=932400279958679638&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hobby-lobby",
      "poi_latitude": "31.3211894",
      "poi_longitude": "-89.3722633",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 601-261-5204",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0cf3-710f-85d4-4b273f34a987.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0cf3-710f-85d4-4b273f34a987",
        "storage_key": "property/6737460151192644/019e1dd9-0cf3-710f-85d4-4b273f34a987.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJJ8D8lhDfnIgRVnBpUx2N8Aw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_947ddc9e-4d63-46dc-8dc6-86d570f6c650",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Sam's Club",
      "poi_type": "Shopping & Retail",
      "poi_address": "6080 US-98, Hattiesburg, MS 39402, USA",
      "poi_short_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_long_description": "People say this store is clean and well-stocked with a wide selection of items, including food, household goods, and clothing. They also highlight the helpful staff and fast checkout process.\n\nSome reviews mention the cafe can be understaffed.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019ea8ff-f003-76c4-a518-cdf27c2a7821.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8ff-f003-76c4-a518-cdf27c2a7821",
        "storage_key": "property/6737460151192644/019ea8ff-f003-76c4-a518-cdf27c2a7821.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.samsclub.com/club/6503-hattiesburg-ms",
      "poi_directions_map_url": "https://maps.google.com/?cid=16194836688630735585&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sams-club",
      "poi_latitude": "31.3184529",
      "poi_longitude": "-89.3810761",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 601-261-2171",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0cf3-710f-85d4-4b273f34a987.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0cf3-710f-85d4-4b273f34a987",
        "storage_key": "property/6737460151192644/019e1dd9-0cf3-710f-85d4-4b273f34a987.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJOeE4VX7fnIgR4WJMFSqev-A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_0e94e91a-b586-4153-8580-1d879b6b2d9f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Crescent City Grill",
      "poi_type": "Restaurants",
      "poi_address": "3810 Hardy St, Hattiesburg, MS 39402, USA",
      "poi_short_description": "Family-friendly Cajun eatery with broad beer & wine lists served amid warm woods & stained glass.",
      "poi_long_description": "People say this restaurant serves delicious gumbo, Mardi Gras pasta, and catfish. They also highlight the fast and attentive service, and the fun, authentic atmosphere.\n\nOther reviews mention the oysters can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019ea8ff-ed67-762d-a128-eb4b5a0d3030.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8ff-ed67-762d-a128-eb4b5a0d3030",
        "storage_key": "property/6737460151192644/019ea8ff-ed67-762d-a128-eb4b5a0d3030.webp",
        "width": 1024,
        "height": 682
      },
      "poi_business_url": "https://crescentcitygrill.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5045843677917808461&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "crescent-city-grill",
      "poi_latitude": "31.324646",
      "poi_longitude": "-89.3461791",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 601-264-0656",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0cbf-71dc-9f12-48c766facff1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0cbf-71dc-9f12-48c766facff1",
        "storage_key": "property/6737460151192644/019e1dd9-0cbf-71dc-9f12-48c766facff1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5xbb4uvenIgRTQdxThdwBkY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_65ee1749-9dfe-419d-b923-df9a92c5df16",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Buffalo Wild Wings",
      "poi_type": "Restaurants",
      "poi_address": "3 Churchill St, Hattiesburg, MS 39402, USA",
      "poi_short_description": "Chain dishing up wings, tenders & burgers, plus sauces ranging from sweet to very spicy.",
      "poi_long_description": "People say this sports bar offers delicious, crispy, and flavorful wings with a wide variety of sauces, along with other solid food options. They also highlight the fun, welcoming atmosphere, and the friendly, attentive staff who provide excellent service.\n\nSome reviews mention the service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019ea8ff-ef21-739e-a1ed-8d1df610e9c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8ff-ef21-739e-a1ed-8d1df610e9c0",
        "storage_key": "property/6737460151192644/019ea8ff-ef21-739e-a1ed-8d1df610e9c0.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.buffalowildwings.com/locations/us/ms/hattiesburg/3-churchill-street/sports-bar-355?utm_source=google-my-business&utm_medium=organic&utm_campaign=website-link&y_source=1_MjAxNjYxMTYyMy03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=14663778705389026739&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "buffalo-wild-wings",
      "poi_latitude": "31.3243462",
      "poi_longitude": "-89.3500329",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 601-288-7777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0cbf-71dc-9f12-48c766facff1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0cbf-71dc-9f12-48c766facff1",
        "storage_key": "property/6737460151192644/019e1dd9-0cbf-71dc-9f12-48c766facff1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJL_kStejenIgRs32mXwo1gMs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_wings_restaurant"
    },
    {
      "id": "custom_a7487534-1b43-4680-abbc-4e9023a2e698",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Mahogany Bar",
      "poi_type": "Restaurants",
      "poi_address": "3810 Hardy St, Hattiesburg, MS 39402, USA",
      "poi_short_description": "Craft-beer and wine bar with a casual vibe, serving Cajun fare and hosting live music events.",
      "poi_long_description": "People say this bar offers great burgers, crabmeat wontons, and corn and crab bisque. They highlight the pleasant and relaxing atmosphere, especially on the patio, and the friendly and efficient service. They also like the happy hour deals on select cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019ea8ff-f310-75a5-88b2-7cba47d72eae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8ff-f310-75a5-88b2-7cba47d72eae",
        "storage_key": "property/6737460151192644/019ea8ff-f310-75a5-88b2-7cba47d72eae.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://mahoganybar.net/?y_source=1_NTQ1MTk2NzAtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=9265708018778598696&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mahogany-bar",
      "poi_latitude": "31.3246116",
      "poi_longitude": "-89.34628289999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 601-264-0656",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dda-0e10-76b8-a750-0dc4c103e940.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-0e10-76b8-a750-0dc4c103e940",
        "storage_key": "property/6737460151192644/019e1dda-0e10-76b8-a750-0dc4c103e940.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr2D74uvenIgRKG3J61loloA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_f884188d-33df-4d82-a641-55721b504520",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Strick's Bar-B-Q & Catering",
      "poi_type": "Restaurants",
      "poi_address": "3802 W 4th St, Hattiesburg, MS 39401, USA",
      "poi_short_description": "Longstanding eatery offering BBQ pork, ribs & chicken, plus smoked brisket.",
      "poi_long_description": "Customers consistently praise this BBQ restaurant for its delicious and tender brisket and ribs, alongside generous portions and reasonable prices. The friendly staff and flavorful fried okra are also frequently highlighted.\n\nSome reviews mention the meat can be lacking in flavor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019ea8ff-f55f-713b-bd70-ddeb5b1c66b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8ff-f55f-713b-bd70-ddeb5b1c66b4",
        "storage_key": "property/6737460151192644/019ea8ff-f55f-713b-bd70-ddeb5b1c66b4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.stricksbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17322455089594422747&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "stricks-bar-b-q--catering",
      "poi_latitude": "31.3352778",
      "poi_longitude": "-89.3461111",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 601-264-2502",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0cbf-71dc-9f12-48c766facff1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0cbf-71dc-9f12-48c766facff1",
        "storage_key": "property/6737460151192644/019e1dd9-0cbf-71dc-9f12-48c766facff1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSxoftMbenIgR29XuLCC5ZfA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_24eece92-eee4-44a3-95c9-2a9c77aabc08",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Tabella Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "3720 Hardy St #23A, Hattiesburg, MS 39402, USA",
      "poi_short_description": "Relaxed locale for Italian & American meals, including family-style dishes, plus wine & cocktails.",
      "poi_long_description": "Diners like this Italian restaurant's excellent food, including lasagna, toasted ravioli, and grilled salmon, with many gluten-free options. They also highlight the friendly and attentive staff, as well as the calm, romantic setting.\n\nSome reviews mention the staff can be unprofessional.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019ea8ff-f8df-730b-a1b4-2ce2e84cb122.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8ff-f8df-730b-a1b4-2ce2e84cb122",
        "storage_key": "property/6737460151192644/019ea8ff-f8df-730b-a1b4-2ce2e84cb122.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://tabellapronto.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9617892330929437919&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tabella-italian-restaurant",
      "poi_latitude": "31.3232951",
      "poi_longitude": "-89.34601579999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 601-255-5488",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0cbf-71dc-9f12-48c766facff1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0cbf-71dc-9f12-48c766facff1",
        "storage_key": "property/6737460151192644/019e1dd9-0cbf-71dc-9f12-48c766facff1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdTuXm-venIgR37wAAR6eeYU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_df7040b1-4e4a-412e-a19a-b65188b777f3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "The Grand Hattiesburg by Santikos",
      "poi_type": "Entertainment",
      "poi_address": "100 Grand Dr, Hattiesburg, MS 39401, USA",
      "poi_short_description": "Modern cinema featuring premium options such as IMAX, Dolby Atmos, and comfy recliners.",
      "poi_long_description": "People say this movie theater offers comfortable, reclining seats and a wide variety of snacks, including adult beverages and delicious pizza. They also highlight the friendly and welcoming staff, as well as the clean facilities and restrooms.\n\nSome reviews mention the seats can be neglected.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019ea8ff-f4f7-7389-a39a-1a6b7bb44cf6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8ff-f4f7-7389-a39a-1a6b7bb44cf6",
        "storage_key": "property/6737460151192644/019ea8ff-f4f7-7389-a39a-1a6b7bb44cf6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.santikos.com/hattiesburg/the-grand-hattiesburg/theater-info",
      "poi_directions_map_url": "https://maps.google.com/?cid=4227092826478463826&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-grand-hattiesburg-by-santikos",
      "poi_latitude": "31.3314898",
      "poi_longitude": "-89.3500816",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 877-691-0734",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dda-0e04-7454-a60d-99c13b84b7fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-0e04-7454-a60d-99c13b84b7fb",
        "storage_key": "property/6737460151192644/019e1dda-0e04-7454-a60d-99c13b84b7fb.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJe0iYusLenIgRUsvZkoemqTo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_950d1969-11c4-4731-975a-ad90ecd6d6b3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Updown Trampoline Park",
      "poi_type": "Entertainment",
      "poi_address": "101 S 41st Ave, Hattiesburg, MS 39402, USA",
      "poi_short_description": "Roomy indoor trampoline park, also offering laser tag, fitness classes & a snack bar.",
      "poi_long_description": "Visitors say this amusement center provides a clean and fun experience for families, with exciting activities like trampolines, a ninja warrior course, laser tag, and arcade games. They also highlight the friendly and helpful staff, and appreciate the value of the party packages which include food and no clean-up.\n\nSome reviews mention the prices can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019ea8ff-f893-7671-bebd-fd0287c6e5c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8ff-f893-7671-bebd-fd0287c6e5c3",
        "storage_key": "property/6737460151192644/019ea8ff-f893-7671-bebd-fd0287c6e5c3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://updowntrampolinepark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9336739901073620360&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "updown-trampoline-park",
      "poi_latitude": "31.323658",
      "poi_longitude": "-89.349277",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 601-909-9060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0de8-77c8-8b33-34148810ff7f",
        "storage_key": "property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1UuzM-_enIgRiH21y3jDkoE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_b3a73fa6-5a67-47ca-aaf0-29d3272dc722",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Time Will Tell Escape Games",
      "poi_type": "Entertainment",
      "poi_address": "2206 Hardy St, Hattiesburg, MS 39401, USA",
      "poi_short_description": "Entertainment option where visitors must solve puzzles to escape themed rooms.",
      "poi_long_description": "People say this escape room offers creative and immersive games with well-thought-out storylines and challenging puzzles. They also highlight the friendly, helpful, and accommodating staff who provide excellent guidance and hints. Visitors mention it's a super fun experience, perfect for families, friends, or date nights, and many plan to return.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019ea8ff-fa22-70f9-af39-003945e10928.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8ff-fa22-70f9-af39-003945e10928",
        "storage_key": "property/6737460151192644/019ea8ff-fa22-70f9-af39-003945e10928.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://timewilltellescapegames.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3522961471041682272&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "time-will-tell-escape-games",
      "poi_latitude": "31.3243918",
      "poi_longitude": "-89.32453199999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 601-813-6951",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0de8-77c8-8b33-34148810ff7f",
        "storage_key": "property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ0GnVfognYgRYLvT3soS5DA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_b699b5ce-fa0c-471c-b560-9a5f4f4d9187",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Alley Cats Axe Throwing",
      "poi_type": "Entertainment",
      "poi_address": "100 Dudley West Conner St",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6004b4c9-6406-4ea1-9118-8f4b3686d796",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Laser Mania",
      "poi_type": "Entertainment",
      "poi_address": "905 Hardy St #223, Hattiesburg, MS 39401, USA",
      "poi_short_description": "Black-lit hangout for laser tag battles and old-school arcade machines.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019ea8ff-f8eb-71bc-86ba-f4843b295a5f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8ff-f8eb-71bc-86ba-f4843b295a5f",
        "storage_key": "property/6737460151192644/019ea8ff-f8eb-71bc-86ba-f4843b295a5f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://lasermania.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12837803825027082834&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "laser-mania",
      "poi_latitude": "31.3253517",
      "poi_longitude": "-89.3053091",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 601-543-0072",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0de8-77c8-8b33-34148810ff7f",
        "storage_key": "property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWTvGRj_cnIgRUurjro8KKbI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_35cf4331-2916-413b-a330-0266be175f2c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Serengeti Springs at the Hattiesburg Zoo",
      "poi_type": "Entertainment",
      "poi_address": "1700 Hardy St, Hattiesburg, MS 39401, USA",
      "poi_short_description": "Opened in 2024, this water park offers a lazy river and a splash pad, plus birthday parties.",
      "poi_long_description": "Some visitors say this water park offers a fun lazy river and slides for all ages, and they appreciate the attentive lifeguards and clean facilities.\n\nOther reviews mention the park can be crowded and there aren't enough tubes for the lazy river.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019ea8ff-fbb8-746a-a360-47a736a04fd7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8ff-fbb8-746a-a360-47a736a04fd7",
        "storage_key": "property/6737460151192644/019ea8ff-fbb8-746a-a360-47a736a04fd7.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://hattiesburgzoo.com/serengeti/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6188876171897349928&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "serengeti-springs-at-the-hattiesburg-zoo",
      "poi_latitude": "31.32439889999999",
      "poi_longitude": "-89.31718269999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 601-602-5777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0de8-77c8-8b33-34148810ff7f",
        "storage_key": "property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7QtZQADdnIgRKCfSmBZO41U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_attraction"
    },
    {
      "id": "custom_dc9c86c4-aed1-4281-8f9a-16ebe5054b10",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Red Bluff",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Foxworth, MS 39483, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019ea8ff-ff40-7608-84d0-56fb8b95e207.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8ff-ff40-7608-84d0-56fb8b95e207",
        "storage_key": "property/6737460151192644/019ea8ff-ff40-7608-84d0-56fb8b95e207.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17308804504934812651&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "red-bluff",
      "poi_latitude": "31.3236122",
      "poi_longitude": "-89.9449091",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0de8-77c8-8b33-34148810ff7f",
        "storage_key": "property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvwlKYABfnYgR6wtSw_05NfA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_1db823e6-e2d9-44fa-a9a2-267d62e99694",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "TrustCare Hattiesburg",
      "poi_type": "Health and Wellness",
      "poi_address": "6176 US-98, Hattiesburg, MS 39402, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019ea8ff-fc6c-7621-bc80-93b46dc7d63a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8ff-fc6c-7621-bc80-93b46dc7d63a",
        "storage_key": "property/6737460151192644/019ea8ff-fc6c-7621-bc80-93b46dc7d63a.webp",
        "width": 999,
        "height": 562
      },
      "poi_business_url": "https://trustcarehealth.com/location/ms-highway-98-west-hattiesburg?utm_source=google&utm_medium=organic&utm_campaign=gbp-listing&utm_content=highway-98-west-hattiesburg",
      "poi_directions_map_url": "https://maps.google.com/?cid=15837256372105308966&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "trustcare-hattiesburg",
      "poi_latitude": "31.3198757",
      "poi_longitude": "-89.38846579999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 601-475-0444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0de8-77c8-8b33-34148810ff7f",
        "storage_key": "property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJucfzJSffnIgRJusg1MI8yds",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_ebeb539a-8e04-449a-a5af-925d859654df",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Maxem Health Urgent Care Oak Grove",
      "poi_type": "Health and Wellness",
      "poi_address": "4910 Old Hwy 11, Hattiesburg, MS 39402, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019ea8ff-fcdd-74bd-a7c9-cb014b215ff8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8ff-fcdd-74bd-a7c9-cb014b215ff8",
        "storage_key": "property/6737460151192644/019ea8ff-fcdd-74bd-a7c9-cb014b215ff8.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "https://maxemhealthurgentcare.com/locations-2/oak-grove/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5884739094947980817&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "maxem-health-urgent-care-oak-grove",
      "poi_latitude": "31.2866749",
      "poi_longitude": "-89.4138219",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 769-390-7981",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0de8-77c8-8b33-34148810ff7f",
        "storage_key": "property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdcju2RohnYgREWY6NgfLqlE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_805d2a49-828e-4bbf-a871-d9e12be9eb91",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Rainforest Carwash & Oil Change Hardy",
      "poi_type": "Transportation & Transit",
      "poi_address": "5026 Hardy St, Hattiesburg, MS 39402, USA",
      "poi_short_description": "Automatic car wash chain offering washes along with oil changes and detailing services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019ea8ff-fdf5-70b8-a0dd-37d5c3adf3f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8ff-fdf5-70b8-a0dd-37d5c3adf3f5",
        "storage_key": "property/6737460151192644/019ea8ff-fdf5-70b8-a0dd-37d5c3adf3f5.webp",
        "width": 1280,
        "height": 800
      },
      "poi_business_url": "https://www.rainforestclean.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13534219887220345737&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "rainforest-carwash--oil-change-hardy",
      "poi_latitude": "31.322082",
      "poi_longitude": "-89.3699216",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 601-296-1967",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0de8-77c8-8b33-34148810ff7f",
        "storage_key": "property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5dmRbBrfnIgRicvLsUc107s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "car_wash"
    },
    {
      "id": "custom_ab1b0ecf-70d7-4d3e-9ef9-66954bb85a44",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Hernandez Tire Shop",
      "poi_type": "Transportation & Transit",
      "poi_address": "902 Hardy St, Pinehurst St, Hattiesburg, MS 39401, USA",
      "poi_short_description": "Retailer stocking new and used tires, as well as rims, patches and balancing services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019ea900-00bd-7364-861a-f6b3215bef79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea900-00bd-7364-861a-f6b3215bef79",
        "storage_key": "property/6737460151192644/019ea900-00bd-7364-861a-f6b3215bef79.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3320489425947895087&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hernandez-tire-shop",
      "poi_latitude": "31.3244504",
      "poi_longitude": "-89.30390009999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 601-470-9944",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0cf3-710f-85d4-4b273f34a987.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0cf3-710f-85d4-4b273f34a987",
        "storage_key": "property/6737460151192644/019e1dd9-0cf3-710f-85d4-4b273f34a987.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ6X0al9XdnIgRL6UQSoq_FC4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tire_shop"
    },
    {
      "id": "custom_3efabe95-fdfe-4f1f-a63a-f1bc42b344e1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "United States Postal Service",
      "poi_type": "Major Employers & Offices",
      "poi_address": "220 S 40th Ave, Hattiesburg, MS 39402, USA",
      "poi_short_description": "Government agency offering regular mail and package delivery, as well as money orders.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019ea900-007e-7599-9901-55f1933bfa6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea900-007e-7599-9901-55f1933bfa6e",
        "storage_key": "property/6737460151192644/019ea900-007e-7599-9901-55f1933bfa6e.webp",
        "width": 1280,
        "height": 765
      },
      "poi_business_url": "https://tools.usps.com/locations/details/1366472?utm_source=google-my-business-url&utm_medium=search&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=11549634176354330720&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "united-states-postal-service",
      "poi_latitude": "31.3219858",
      "poi_longitude": "-89.34688080000001",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 800-275-8777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-1091-74b2-a4a4-ec3a88e69f0d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1091-74b2-a4a4-ec3a88e69f0d",
        "storage_key": "property/6737460151192644/019e1dd9-1091-74b2-a4a4-ec3a88e69f0d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVa1Rmu7enIgRYKhPPxeLSKA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "post_office"
    },
    {
      "id": "custom_f30552a8-f345-4d5c-b695-fa5b6e25f5f5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Category 5 Smash Room",
      "poi_type": "Entertainment",
      "poi_address": "214 W Pine St, Hattiesburg, MS 39401, USA",
      "poi_short_description": "Rage room (aka smash room) offering stress relief by smashing bottles and other objects.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019ea900-044e-75fe-a7e7-0dca67ae45ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea900-044e-75fe-a7e7-0dca67ae45ce",
        "storage_key": "property/6737460151192644/019ea900-044e-75fe-a7e7-0dca67ae45ce.webp",
        "width": 1123,
        "height": 1280
      },
      "poi_business_url": "http://www.cat5smashroom.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7387484441594507813&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "category-5-smash-room",
      "poi_latitude": "31.3260902",
      "poi_longitude": "-89.2915055",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 601-329-2305",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0de8-77c8-8b33-34148810ff7f",
        "storage_key": "property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZa_dcWPdnIgRJTL3hPWdhWY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "custom_bccedafe-4634-4140-8c37-6c7ac282b21b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Southern Prohibition Brewing",
      "poi_type": "Restaurants",
      "poi_address": "301 Mobile St, Hattiesburg, MS 39401, USA",
      "poi_short_description": "Casual beer bar with outdoor seating offering familiar eats and signature brews plus wine, cocktails and spirits.",
      "poi_long_description": "People say this brewpub offers delicious brussel sprouts, tater tots, and a variety of craft beers, including the Mississippi Fire Ant red ale and SuzyB blonde. They highlight the cool vibe, friendly staff, and generous management. They also like the unique art on the beer cans.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019ea900-044d-7760-a434-5d544762b2f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea900-044d-7760-a434-5d544762b2f8",
        "storage_key": "property/6737460151192644/019ea900-044d-7760-a434-5d544762b2f8.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://soprobrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7026138150803127660&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "southern-prohibition-brewing",
      "poi_latitude": "31.3300167",
      "poi_longitude": "-89.2897546",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 601-602-4871",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dda-0e10-76b8-a750-0dc4c103e940.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-0e10-76b8-a750-0dc4c103e940",
        "storage_key": "property/6737460151192644/019e1dda-0e10-76b8-a750-0dc4c103e940.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV5q0SWfcnIgRbL1wDWzbgWE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewpub"
    },
    {
      "id": "custom_e6a186a9-3715-4e92-9ffc-2ca1e9dc0389",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Hattiesburg Coca-Cola Bottling Company",
      "poi_type": "Major Employers & Offices",
      "poi_address": "201 Coca Cola St, Hattiesburg, MS 39402, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019ea903-1dd3-7289-8279-8187c270bcca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea903-1dd3-7289-8279-8187c270bcca",
        "storage_key": "property/6737460151192644/019ea903-1dd3-7289-8279-8187c270bcca.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://cocacolaunited.com/locations/hattiesburg",
      "poi_directions_map_url": "https://maps.google.com/?cid=17356737455471896872&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hattiesburg-coca-cola-bottling-company",
      "poi_latitude": "31.326641",
      "poi_longitude": "-89.36029049999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 601-264-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0de8-77c8-8b33-34148810ff7f",
        "storage_key": "property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZZyJ3eHenIgRKKkefcGE3_A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_639aeb4e-96d3-46ed-9178-6dedf4b1ce61",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Kohler Engines Plant 1",
      "poi_type": "Shopping & Retail",
      "poi_address": "182 J M Tatum Industrial Dr, Hattiesburg, MS 39401, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019ea903-1e90-71e9-9b2a-8a583eb0c579.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea903-1e90-71e9-9b2a-8a583eb0c579",
        "storage_key": "property/6737460151192644/019ea903-1e90-71e9-9b2a-8a583eb0c579.webp",
        "width": 1280,
        "height": 512
      },
      "poi_business_url": "http://www.kohlerengines.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=185490395232293211&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kohler-engines-plant-1",
      "poi_latitude": "31.2685947",
      "poi_longitude": "-89.26967619999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 601-582-3555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0de8-77c8-8b33-34148810ff7f",
        "storage_key": "property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMwdPcl3dnIgRW1ERHYj-kgI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_a45bac47-52bb-44cb-b6e5-bb54040d305a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "MDR Construction Inc",
      "poi_type": "Major Employers & Offices",
      "poi_address": "621 E Baylis Chapel Rd, Columbia, MS 39429, USA",
      "poi_short_description": "Power line construction company restoring power for neighborhoods after hurricanes, tornadoes and ice storms.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019ea903-1d26-72dc-acd6-cb4a2fa8c96a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea903-1d26-72dc-acd6-cb4a2fa8c96a",
        "storage_key": "property/6737460151192644/019ea903-1d26-72dc-acd6-cb4a2fa8c96a.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "https://www.mdrpowerline.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16363263056236565440&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mdr-construction-inc",
      "poi_latitude": "31.2448425",
      "poi_longitude": "-89.6618804",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 601-731-2716",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0de8-77c8-8b33-34148810ff7f",
        "storage_key": "property/6737460151192644/019e1dd9-0de8-77c8-8b33-34148810ff7f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaVlacJ4VnYgRwNNAqQ39FeM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_contractor"
    },
    {
      "id": "custom_2577bfb2-a100-433c-9890-f710042f367b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Howard Industries Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1840 Progress Ave. Columbus, OH 43207",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a6744b43-a1db-4cd0-87f0-9cbacb5e1ceb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "poi_name": "Regions Bank",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4800 Hardy St, Hattiesburg, MS 39402, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019ea903-1c74-7338-9c17-0f96da56d632.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea903-1c74-7338-9c17-0f96da56d632",
        "storage_key": "property/6737460151192644/019ea903-1c74-7338-9c17-0f96da56d632.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://www.regions.com/locator/ms/hattiesburg/full-service-branch-4800-hardy-st?cid=localListing_google",
      "poi_directions_map_url": "https://maps.google.com/?cid=274749626355793860&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "regions-bank",
      "poi_latitude": "31.3229581",
      "poi_longitude": "-89.3624587",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 601-705-9310",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019ea903-256e-738f-8e2a-4d48dfad95bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ea903-256e-738f-8e2a-4d48dfad95bd",
        "storage_key": "property/6737460151192644/019ea903-256e-738f-8e2a-4d48dfad95bd.webp",
        "width": 192,
        "height": 139
      },
      "poi_google_place_id": "ChIJR6NRzx3fnIgRxL8bWVQb0AM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bank"
    }
  ],
  "office_hours": [
    {
      "id": "custom_602533e4-211d-4b3e-8f29-e3f127ac4800",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_f7db5916-c69d-4f19-876f-5d71b8abba7c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_919a0e08-53e7-49cc-bbf6-e98be7da9f67",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_6927bb3e-a881-450d-8813-a374f666c15b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_7a39db1f-d94e-404a-af48-adefef68438a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_860c754e-a538-4767-a25a-b349dadf54f7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "16:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_6c93f8c4-2dd4-42e2-89ce-4af0297ab2da",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "rating": "5",
      "name": "Abigail Calmo",
      "text": "The apartments look nice and the area feels peaceful. It seems like a good community with good management and maintenance",
      "date": "2026-02-13",
      "title": "false"
    },
    {
      "id": "custom_8fb71346-4dec-484d-9130-fcfdfdd72d55",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "rating": "5",
      "name": "Evan Sparks",
      "text": "My experience moving into Reserve at Long Point was great. The process was seamless and stress-free, thanks in large part to the outstanding assistance from Ryan and Shayla. They were both incredibly helpful, professional, and quick to respond to all my questions. I'm also really impressed with how beautiful and well-maintained the community is. I feel safe and secure here, which goes a long way. Highly recommended!",
      "date": "2025-08-29",
      "title": "false"
    },
    {
      "id": "custom_44bb65b3-84f5-4017-bfe6-b2be9a358a80",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "rating": "5",
      "name": "Cassidy Cartwright",
      "text": "Moving into my new apartment was surprisingly easy. From the start, the leasing office was super responsive. They provided clear instructions, and had all the paperwork ready ahead of time. On the actual day, everything went smoothly. The keys were ready when I arrived, the apartment was clean and move-in ready, and I was able to start unloading right away. Parking was accessible.",
      "date": "2025-08-01",
      "title": "false"
    },
    {
      "id": "custom_75c9d9aa-24ad-47c7-9e8a-074f09f3037d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "rating": "5",
      "name": "Megan Walker",
      "text": "Management is great and always very good with responses! Maintenance is quick! Great place to live!",
      "date": "2025-08-01",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_617bc98b-5eb7-4a27-8769-692ef11d5234",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019e66b6-f4cd-77dd-b6d3-ec5e45a658be.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e66b6-f4cd-77dd-b6d3-ec5e45a658be",
        "storage_key": "property/6737460151192644/019e66b6-f4cd-77dd-b6d3-ec5e45a658be.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Entrance",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com?tour=6865d6ef7f1d1bd576531d13"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01993e9b-e66f-75fe-a1c3-9ba9718c59a8",
      "lead_source": "LANDING_PAGE",
      "name": "rreaf-reserve-at-long-point-lp",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644"
    },
    {
      "lead_collector_id": "019a1855-6c80-7119-a6f2-18dec45570c0",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "rreaf-reserve-at-long-point-new",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-hattiesburg-ms",
      "search_query": "apartments with in-unit laundry Hattiesburg MS",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry",
      "h2_subtitle": "Discover in-unit laundry apartments in Hattiesburg, MS. Enjoy modern living at Reserve at Long Point with convenient amenities and floor plans.",
      "page_copy": "At Reserve at Long Point, you'll experience the comfort of having your own in-unit laundry in our spacious apartments. Situated in Hattiesburg, MS, our property offers a blend of convenience and modern amenities that make life straightforward and stress-free. Choose from a variety of floor plans, including one, two, and three-bedroom options, all designed with your comfort in mind.\n\nBeyond in-unit laundry, we provide residents with exemplary features such as a sparkling swimming pool, a state-of-the-art 24-hour fitness center, and a charming dog park for your furry friends. Our community also includes essential on-site amenities like gas grills and a business center. Whether you're taking a stroll through the lush courtyards or mingling at the clubhouse, Reserve at Long Point is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019d0785-4d6c-75a0-93dc-d1b3653a1eba.webp",
      "featured_image_media": {
        "alt_text": "Living room with blue sofa, yellow accents, and a fireplace.",
        "public_id": "019d0785-4d6c-75a0-93dc-d1b3653a1eba",
        "storage_key": "property/6737460151192644/019d0785-4d6c-75a0-93dc-d1b3653a1eba.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Hattiesburg Apartments with In-Unit Laundry",
      "seo_description": "Find Hattiesburg, MS apartments with in-unit laundry at Reserve at Long Point. Enjoy premier amenities and a welcoming community experience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-dog-park-forrest-county-ms",
      "search_query": "pet-friendly apartments with dog park Forrest County",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments with Dog Park",
      "h2_subtitle": "Explore pet-friendly living with a dog park in Forrest County. Reserve at Long Point offers comfort for you and your pets.",
      "page_copy": "Welcome to Reserve at Long Point, where pets are cherished members of the family. Nestled in Forrest County, our pet-friendly apartments include a delightful dog park, perfect for your furry companions to frolic and socialize. Whether you opt for our one, two, or three-bedroom layouts, you'll find a home designed with both style and functionality in mind.\n\nOur community goes beyond just being pet-friendly. It offers a variety of amenities tailored for your lifestyle, such as a refreshing swimming pool, an inviting courtyard, and a 24-hour fitness center. Plus, enjoy additional features like gas grills and a business center, making life at Reserve at Long Point not just convenient, but incredibly enriching. Discover a refined living experience where both you and your pets feel right at home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019d0785-4d6c-75a0-93dc-d1b3653a1eba.webp",
      "featured_image_media": {
        "alt_text": "Living room with blue sofa, yellow accents, and a fireplace.",
        "public_id": "019d0785-4d6c-75a0-93dc-d1b3653a1eba",
        "storage_key": "property/6737460151192644/019d0785-4d6c-75a0-93dc-d1b3653a1eba.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Forrest County Pet-Friendly Apartments",
      "seo_description": "Reserve at Long Point in Forrest County offers pet-friendly apartments with a dog park. Enjoy a welcoming community with superb amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "generator",
      "page_item_url": "apartments-with-pool-hattiesburg-south-area",
      "search_query": "apartments with a pool in Hattiesburg/South Area",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Hattiesburg",
      "h2_subtitle": "Find premier apartments with a pool in the Hattiesburg/South Area. Relax and unwind at Reserve at Long Point with top amenities.",
      "page_copy": "Discover the ultimate in relaxation at Reserve at Long Point, where we offer exquisite apartments featuring a sparkling pool in the Hattiesburg/South Area. Whether you choose from our one, two, or three-bedroom options, you'll enjoy a well-rounded living experience that combines style, comfort, and convenience.\n\nOur vibrant community offers more than just a pristine pool. Residents also have access to a 24-hour fitness center, a welcoming dog park, and beautifully landscaped courtyards. Additional amenities such as gas grills and a business center further enhance your living experience at Reserve at Long Point. Come see why our community is the perfect blend of leisure and luxury in the heart of Hattiesburg.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019d0785-4d6c-75a0-93dc-d1b3653a1eba.webp",
      "featured_image_media": {
        "alt_text": "Living room with blue sofa, yellow accents, and a fireplace.",
        "public_id": "019d0785-4d6c-75a0-93dc-d1b3653a1eba",
        "storage_key": "property/6737460151192644/019d0785-4d6c-75a0-93dc-d1b3653a1eba.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Hattiesburg Apartments with a Pool",
      "seo_description": "Reserve at Long Point offers Hattiesburg/South Area apartments with a pool and fantastic amenities. Discover your new home today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-near-39401",
      "search_query": "air-conditioned apartments near 39401",
      "category": "Amenity",
      "h1_title": "Air-Conditioned Apartments Near 39401",
      "h2_subtitle": "Experience comfort in air-conditioned apartments near the 39401 area. Reserve at Long Point offers cooling amenities and spacious living.",
      "page_copy": "At Reserve at Long Point, enjoy the comfort of air-conditioned apartments conveniently located near the 39401 area. Our community offers a variety of floor plans, including one, two, and three-bedroom options, all designed for optimal comfort and convenience.\n\nApart from the bliss of cool interiors, explore our extensive amenities that include a shimmering swimming pool, a well-equipped 24-hour fitness center, and a friendly dog park for pet owners. Discover the added charm of our gas grills, inviting courtyards, and a business center, all of which contribute to an enriching lifestyle at Reserve at Long Point. Whether you're relaxing indoors or enjoying the community features, our apartments are designed to suit your needs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019d0785-4d6c-75a0-93dc-d1b3653a1eba.webp",
      "featured_image_media": {
        "alt_text": "Living room with blue sofa, yellow accents, and a fireplace.",
        "public_id": "019d0785-4d6c-75a0-93dc-d1b3653a1eba",
        "storage_key": "property/6737460151192644/019d0785-4d6c-75a0-93dc-d1b3653a1eba.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air-Conditioned Apartments Near 39401",
      "seo_description": "Find air-conditioned apartments near the 39401 area at Reserve at Long Point. Enjoy premium amenities and relaxed living in Hattiesburg.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "generator",
      "page_item_url": "apartments-with-dishwasher-stainless-steel-hattiesburg",
      "search_query": "apartments with dishwasher and stainless steel appliances Hattiesburg",
      "category": "Amenity",
      "h1_title": "Modern Apartments with Stainless Steel Appliances",
      "h2_subtitle": "Discover apartments in Hattiesburg featuring dishwashers and stainless steel appliances. Reserve at Long Point offers sophisticated living.",
      "page_copy": "Reserve at Long Point sets the standard for refined living in Hattiesburg, offering apartments equipped with modern conveniences like dishwashers and stainless steel appliances. Choose from our spacious one, two, or three-bedroom layouts, each designed with elegance and practicality in mind.\n\nOur community doesn’t stop at indoor luxuries. Enjoy an array of amenities that enhance your lifestyle, including a stunning swimming pool, a dynamic 24-hour fitness center, and a dog park perfect for pet lovers. Gas grills, scenic courtyards, and a fully equipped business center are additional features that make living at Reserve at Long Point both convenient and delightful. Experience premium living with all the amenities you desire right in Hattiesburg.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019d0785-4d6c-75a0-93dc-d1b3653a1eba.webp",
      "featured_image_media": {
        "alt_text": "Living room with blue sofa, yellow accents, and a fireplace.",
        "public_id": "019d0785-4d6c-75a0-93dc-d1b3653a1eba",
        "storage_key": "property/6737460151192644/019d0785-4d6c-75a0-93dc-d1b3653a1eba.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Hattiesburg Apartments with Modern Appliances",
      "seo_description": "Reserve at Long Point offers Hattiesburg apartments with dishwashers and stainless steel appliances. Enjoy stylish living with premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-hattiesburg-ms",
      "search_query": "two bedroom apartments hattiesburg ms",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Hattiesburg, MS",
      "h2_subtitle": "Explore spacious two bedroom apartments in Hattiesburg, MS at Reserve at Long Point. Ideal for comfortable living with great amenities.",
      "page_copy": "At Reserve at Long Point, discover the ideal two bedroom apartments in Hattiesburg, MS. Offering thoughtfully designed floor plans, each apartment is crafted to provide ample living space while integrating modern amenities for superior comfort and style.\n\nSituated in a vibrant community, residents can soak up the benefits of a refreshing swimming pool, a state-of-the-art 24-hour fitness center, and a dog-friendly park. The availability of gas grills, a business center, and picturesque courtyards further elevates the living experience. Whether you're starting fresh or seeking a more spacious abode, our two bedroom options in Hattiesburg offer an excellent blend of convenience and luxury.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019d0785-4d6c-75a0-93dc-d1b3653a1eba.webp",
      "featured_image_media": {
        "alt_text": "Living room with blue sofa, yellow accents, and a fireplace.",
        "public_id": "019d0785-4d6c-75a0-93dc-d1b3653a1eba",
        "storage_key": "property/6737460151192644/019d0785-4d6c-75a0-93dc-d1b3653a1eba.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Hattiesburg, MS",
      "seo_description": "Find spacious two bedroom apartments in Hattiesburg, MS at Reserve at Long Point. Enjoy modern living with outstanding amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-forrest-county",
      "search_query": "three bedroom apartments forrest county",
      "category": "Floorplan",
      "h1_title": "Spacious Three Bedroom Apartments in Forrest County",
      "h2_subtitle": "Discover three bedroom apartments in Forrest County at Reserve at Long Point. Ideal for families or roommates seeking comfort and space.",
      "page_copy": "Welcome to Reserve at Long Point, where you can find spacious three bedroom apartments in Forrest County. Each apartment is thoughtfully designed with ample space, making it ideal for families or individuals seeking room to grow and thrive.\n\nOur community is richly equipped with amenities that complement your lifestyle, including a sparkling swimming pool, a versatile 24-hour fitness center, and an inviting dog park. For those who enjoy the outdoors, our gas grills and scenic courtyards provide the perfect setting to unwind. The added benefit of a business center ensures that you have everything you need close to home. Experience the perfect blend of comfort and convenience in our three bedroom apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019d0785-4d6c-75a0-93dc-d1b3653a1eba.webp",
      "featured_image_media": {
        "alt_text": "Living room with blue sofa, yellow accents, and a fireplace.",
        "public_id": "019d0785-4d6c-75a0-93dc-d1b3653a1eba",
        "storage_key": "property/6737460151192644/019d0785-4d6c-75a0-93dc-d1b3653a1eba.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Forrest County",
      "seo_description": "Explore three bedroom apartments in Forrest County at Reserve at Long Point. Enjoy spacious living with top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192644",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-near-39401",
      "search_query": "one bedroom apartments near 39401",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments Near 39401",
      "h2_subtitle": "Find conveniently located one bedroom apartments near 39401 at Reserve at Long Point. Perfect for stylish and comfortable living in Hattiesburg.",
      "page_copy": "Reserve at Long Point welcomes you to explore our sophisticated one bedroom apartments near the 39401 area. Ideal for singles or couples, these apartments offer a cozy yet modern living experience in Hattiesburg.\n\nWithin our community, residents have access to a wide array of amenities designed to enhance daily life. Enjoy leisurely afternoons at our sparkling swimming pool or stay fit at the 24-hour fitness center. Pet owners will love our welcoming dog park, while communal amenities such as gas grills and a business center provide convenience and enjoyment for all. Discover one bedroom living at its finest, with the perfect balance of comfort and amenities, right near 39401.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192644/019d0785-4d6c-75a0-93dc-d1b3653a1eba.webp",
      "featured_image_media": {
        "alt_text": "Living room with blue sofa, yellow accents, and a fireplace.",
        "public_id": "019d0785-4d6c-75a0-93dc-d1b3653a1eba",
        "storage_key": "property/6737460151192644/019d0785-4d6c-75a0-93dc-d1b3653a1eba.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments Near 39401",
      "seo_description": "Explore one bedroom apartments near 39401 at Reserve at Long Point. Enjoy comfort and modern amenities in Hattiesburg.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3402"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "5028483309"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5026481"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.reservelongpoint.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.reservelongpoint.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.reservelongpoint.com?utm_knock=w"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NHCSNHSJ"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://www.reservelongpoint.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_ar_link",
      "type": "STRING",
      "value": "https://www.reservelongpoint.com?utm_knock=ar"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.reservelongpoint.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.reservelongpoint.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.reservelongpoint.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_fr_link",
      "type": "STRING",
      "value": "https://www.reservelongpoint.com?utm_knock=fr"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.reservelongpoint.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "601-228-6941"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.reservelongpoint.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_ar_title",
      "type": "STRING",
      "value": "Apartment Ratings"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "https://www.reservelongpoint.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_fr_title",
      "type": "STRING",
      "value": "ForRent"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "601-708-8268"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.reservelongpoint.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.reservelongpoint.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.reservelongpoint.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_psa_link",
      "type": "STRING",
      "value": "https://www.reservelongpoint.com?utm_knock=psa"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "601-202-9275"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "601-871-6522"
    },
    {
      "ID": "custom_knock_ar_number",
      "type": "STRING",
      "value": "601-488-1324"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "601-401-4364"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "601-228-0160"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "601-864-1727"
    },
    {
      "ID": "custom_knock_fr_number",
      "type": "STRING",
      "value": "601-530-0088"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "601-258-4110"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.reservelongpoint.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_knock_psa_title",
      "type": "STRING",
      "value": "Paid Social Ads"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "601-688-7408"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.reservelongpoint.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "601-869-5030"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.reservelongpoint.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "601-488-3270"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "601-808-4207"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.reservelongpoint.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "601-673-4479"
    },
    {
      "ID": "custom_knock_psa_number",
      "type": "STRING",
      "value": "601-884-3956"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_bandit_link",
      "type": "STRING",
      "value": "https://www.reservelongpoint.com?utm_knock=bandit"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.reservelongpoint.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "601-265-0851"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "17321251416"
    },
    {
      "ID": "custom_knock_bandit_title",
      "type": "STRING",
      "value": "Bandit Signs"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "601-541-8685"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "601-804-2643"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.reservelongpoint.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "60011ee3e7ac47c1"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.reservelongpoint.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "601-588-8718"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.reservelongpoint.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_bandit_number",
      "type": "STRING",
      "value": "601-891-5368"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "601-565-4746"
    },
    {
      "ID": "custom_knock_outbound_link",
      "type": "STRING",
      "value": "https://www.reservelongpoint.com?utm_knock=outbound"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.reservelongpoint.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "601-574-5205"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "601-514-6885"
    },
    {
      "ID": "custom_knock_outbound_title",
      "type": "STRING",
      "value": "Outbound"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "601-841-1227"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_outbound_number",
      "type": "STRING",
      "value": "601-843-0291"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "601-299-4139"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.reservelongpoint.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://media.multihub.io/property/6737460151192644/019e848a-7734-719d-ad6e-feee99140a70.mp4"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "601-963-5416"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "601-258-4110"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "3402",
  "custom_repli_id": "5028483309",
  "custom_realpage_id": "5026481",
  "custom_knock_a_link": "https://www.reservelongpoint.com?utm_knock=a",
  "custom_knock_g_link": "https://www.reservelongpoint.com?utm_knock=g",
  "custom_knock_w_link": "https://www.reservelongpoint.com?utm_knock=w",
  "custom_google_gtm_id": "GTM-NHCSNHSJ",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_al_link": "https://www.reservelongpoint.com?utm_knock=al",
  "custom_knock_ar_link": "https://www.reservelongpoint.com?utm_knock=ar",
  "custom_knock_cl_link": "https://www.reservelongpoint.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.reservelongpoint.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.reservelongpoint.com?utm_knock=fl",
  "custom_knock_fr_link": "https://www.reservelongpoint.com?utm_knock=fr",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.reservelongpoint.com?utm_knock=gp",
  "custom_knock_w_title": "Property Website",
  "custom_knock_a_number": "601-228-6941",
  "custom_knock_ads_link": "https://www.reservelongpoint.com?utm_knock=ads",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_ar_title": "Apartment Ratings",
  "custom_knock_bnr_link": "https://www.reservelongpoint.com?utm_knock=bnr",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_fr_title": "ForRent",
  "custom_knock_g_number": "601-708-8268",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_lcs_link": "https://www.reservelongpoint.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.reservelongpoint.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.reservelongpoint.com?utm_knock=ppn",
  "custom_knock_psa_link": "https://www.reservelongpoint.com?utm_knock=psa",
  "custom_knock_w_number": "601-202-9275",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_al_number": "601-871-6522",
  "custom_knock_ar_number": "601-488-1324",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_cl_number": "601-401-4364",
  "custom_knock_fb_number": "601-228-0160",
  "custom_knock_fl_number": "601-864-1727",
  "custom_knock_fr_number": "601-530-0088",
  "custom_knock_gp_number": "601-258-4110",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.reservelongpoint.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_knock_psa_title": "Paid Social Ads",
  "custom_ads_subscription": "full_stack",
  "custom_knock_ads_number": "601-688-7408",
  "custom_knock_bcard_link": "https://www.reservelongpoint.com?utm_knock=bcard",
  "custom_knock_bnr_number": "601-869-5030",
  "custom_knock_cfres_link": "https://www.reservelongpoint.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "601-488-3270",
  "custom_knock_lgp_number": "601-808-4207",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.reservelongpoint.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "601-673-4479",
  "custom_knock_psa_number": "601-884-3956",
  "custom_seo_subscription": "essential",
  "custom_knock_bandit_link": "https://www.reservelongpoint.com?utm_knock=bandit",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_flyers_link": "https://www.reservelongpoint.com?utm_knock=flyers",
  "custom_knock_osoc_number": "601-265-0851",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "17321251416",
  "custom_knock_bandit_title": "Bandit Signs",
  "custom_knock_bcard_number": "601-541-8685",
  "custom_knock_cfres_number": "601-804-2643",
  "custom_knock_chatgpt_link": "https://www.reservelongpoint.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "60011ee3e7ac47c1",
  "custom_knock_dirmail_link": "https://www.reservelongpoint.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "601-588-8718",
  "custom_knock_propbro_link": "https://www.reservelongpoint.com?utm_knock=propbro",
  "custom_knock_bandit_number": "601-891-5368",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "601-565-4746",
  "custom_knock_outbound_link": "https://www.reservelongpoint.com?utm_knock=outbound",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.reservelongpoint.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "601-574-5205",
  "custom_knock_dirmail_number": "601-514-6885",
  "custom_knock_outbound_title": "Outbound",
  "custom_knock_propbro_number": "601-841-1227",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_outbound_number": "601-843-0291",
  "custom_knock_revcards_number": "601-299-4139",
  "custom_knock_maintenance_link": "https://www.reservelongpoint.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_property_featured_video": "https://media.multihub.io/property/6737460151192644/019e848a-7734-719d-ad6e-feee99140a70.mp4",
  "custom_knock_maintenance_number": "601-963-5416",
  "custom_ppc_tracking_phone_number": "601-258-4110"
};

export const generatedAt = '2026-10-07T17:12:06.567Z';
